window.theme = window.theme || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
      
      // eslint-disable-next-line no-shadow
      var instance = _.find(this.instances, function(instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (!_.isUndefined(instance) && _.isFunction(instance.onLoad)) {
        instance.onLoad(evt);
      }
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
    .first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element
      .first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = (this.currentVariant && this.currentVariant.featured_image) || {};

      // Check both featured_image (legacy) and featured_media (OS2.0)
      var hasImageChange = variant.featured_image &&
        variantImage.src !== currentVariantImage.src;
      var hasMediaChange = variant.featured_media &&
        (!this.currentVariant || !this.currentVariant.featured_media ||
         variant.featured_media.id !== this.currentVariant.featured_media.id);

      if (!hasImageChange && !hasMediaChange) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (this.currentVariant && variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


theme.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }
  return {
    setTouch: setTouch,
    isTouch: isTouch
  };
})();
theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();
/* ================ MODULES ================ */
theme.Search = (function() {
  var selectors = {
    search: '.header__search, .mobile-header__search',

    searchInput: '.search__input',
    searchToggle: '.search__toggle',
    searchScreen: '.search__fullscreen',
    searchAjax: '.search__ajax.no-js',
    searchResults: '.search__results',
  };
  var searchCache = {};

  function ajaxSearch() {
    $(selectors.searchAjax).each(function() {
      var that = $(this);
      var search = that.find(selectors.searchInput);
      var search_timeout = null;
      var escapeRegExChars = function (value) {
        return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
      };
      var searched_limit = that.data('limit');
      var featured = that.data('featured');
      var featured_limit = that.data('featured_limit');

      search.off('keyup');
      search.on('keyup', function() {
        clearTimeout(search_timeout);

        search_timeout = setTimeout(function () {
          var value = search.val();

          if (value.length > 1) {
            if (value in searchCache) {
              var result = searchCache[value];
              $(selectors.searchResults).html(result.html);
              
              if ($(result.html).find('.not__found').length && !$(result.html).find('.featured_title').length) {
                that.closest(selectors.searchScreen).removeClass('searching');
              }
              else {
                that.closest(selectors.searchScreen).addClass('searching');
              }
            }
            else {
              $(selectors.searchResults).empty();
              
              var data = {
                view: 'search',
                type: 'product',
                searched_limit: searched_limit,
                featured: featured,
                featured_limit: featured_limit,
                q: '*' + value + '*',
                cache: false
              };

              $.ajax({
                url: '/search',
                data: data,
                dataType: 'html',
                type: 'GET',
                beforeSend: function() {
                  that.addClass('loading').addClass('searching');
                },
                complete: function() {
                  that.removeClass('loading');
                },
                success: function(response) {
                  setTimeout(function() {
                    $(selectors.searchResults).html(response);

                    if ($(response).find('.not__found').length && !$(response).find('.featured_title').length) {
                      that.closest(selectors.searchScreen).removeClass('searching');
                    }
                    else {
                      that.closest(selectors.searchScreen).addClass('searching');
                    }

                    // Cache
                    searchCache[value] = {
                      found: true,
                      html: response
                    };
                  }, 650);
                }
              });
            }
          }
          else {
            $(selectors.searchResults).empty();
          }
        }, 500);
      });
      that.removeClass('no-js');
    });
  }
  
  function typeWriter(search) {
    if (typeof $.fn.typed == 'undefined') {
      return false;
    }
    
    var typedtext = '^800 ' + $('.search__label-text', search).data('typedtext'),
        typedtext_2 = $('.search__label-text', search).data('typedtext_2');

    $('.search__label-text', search).typed({
      strings: [typedtext, typedtext_2],
      typeSpeed: 30,
      backSpeed: 20
    });
    
    $(".search__label", search).on("click", function() {
      $(this).fadeOut(200, function() {
        $(this).addClass('hide');
      });
      $(selectors.searchInput, search).focus();
    });
  }

  function searchFullScreen() {
    $(document).off('click', selectors.searchToggle);
    $(document).on('click', selectors.searchToggle, function(evt) {
      evt.preventDefault();

      var body = $('body');
      var search = $(this).closest('.header__search');
      var type_writer = $('.search__label-text', search);
      if (search.hasClass('opened')) {
        body.removeClass('search-opened');
        search.removeClass('opened');
      }
      else {
        body.addClass('search-opened');
        search.addClass('opened');

        $(selectors.searchInput, search).val('');
        $(selectors.searchResults, search).empty();
        $(selectors.searchInput, search).focus();
      }
      
      if (type_writer.length && type_writer.attr('data-first_time') == '0') {
        type_writer.attr('data-first_time', '1');
        typeWriter(search);
      }
    });

    $(document).keyup(function(evt) {
      if (evt.keyCode == 27) {
        var search = $(selectors.search);
        if (search.hasClass('opened')) {
          $('body').removeClass('search-opened');
          search.removeClass('opened');
        }
      }
    });

    $(document).mouseup(function(evt) {
      var container1 = $(selectors.searchToggle);
      var container2 = $(selectors.searchScreen);

      if ((!container1.is(evt.target) && container1.has(evt.target).length === 0) && (!container2.is(evt.target) && container2.has(evt.target).length === 0)) {
        var search = $(selectors.search);
        if (search.hasClass('opened')) {
          $('body').removeClass('search-opened');
          search.removeClass('opened');
        }
      }
    });
  }
  
  function init() {
    if (!$(selectors.search).length) {
      return;
    }

    ajaxSearch();
    searchFullScreen();
  }

  return {
    init: init
  };
})();

theme.CurrencyPicker = (function() {
  var selectors = {
    container: '.currency__picker',
    currency: '.currency__picker .ml__switcher .currency:not(.active)',
  };

  function _formatMoney(price) {
    var formatMoney = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
    formatMoney = formatMoney.replace(theme.settings.currencySymbol, "");
    return '<span class="money"><span class="currency_symbol">' + theme.settings.currencySymbol + '</span>' + formatMoney + '</span>';
  }
  
  function _init() {
    if (!$(selectors.container).length) {
      return;
    }

    // events
    $(selectors.currency).off('click');
    $(selectors.currency).on('click', function(evt) {
      evt.preventDefault();

      var iso_code = $(this).data('iso_code');
      var $form = $(this).closest('form');

      $form.find('[data-iso_code-input]').val(iso_code);
      $form.submit();
    });
  }

  return {
    init: _init,
    formatMoney: _formatMoney
  };
})();

theme.LanguagePicker = (function() {
  var selectors = {
    container: '.language__picker',
    language: '.language__picker .ml__switcher .locale:not(.active)',
  };
  
  function _init() {
    if (!$(selectors.container).length) {
      return;
    }

    // events
    $(selectors.language).off('click');
    $(selectors.language).on('click', function(evt) {
      evt.preventDefault();

      var iso_code = $(this).data('iso_code');
      var $form = $(this).closest('form');

      $form.find('[data-iso_code-input]').val(iso_code);
      $form.submit();
    });
  }

  return {
    init: _init
  };
})();

theme.MiniCart = (function() {
  var selectors = {
    headerSticky: '.header-sticky__placeholder',
    headerCart: '.header__cart .cart__link',
    miniCart: '.minicart',
    miniCartAgree: '.minicart .cart__agree',
    miniCartCheckout: '.minicart .btn-checkout',
    miniCartRemove: '.minicart .item__remove',
    miniCartClose: '.minicart .cart__close, .minicart__overlay',
    miniCartQty: '.minicart .item__qty',
  };
  
  function anim() {
    var tl = new TimelineLite(),
        widget_list = $(".minicart .cart__content"),
        widget_list_item = $(".minicart .cart__item"),
        total = $(".minicart .cart__total"),
        free_shipping = $(".minicart .cart__free-shipping"),
        buttons = $(".minicart .cart__actions"),
        cart_empty_title = $(".minicart .cart__empty"),
        cart_empty_buttons = $(".minicart .cart__return");
    
    if (theme.settings.rtl) {
      tl.fromTo(widget_list, .5, {autoAlpha: 0}, {autoAlpha: 1, ease: Power4.easeIn}, .1);
      tl.staggerFromTo(widget_list_item, .5, {opacity:0, skewX:-20, x:-60}, {opacity:1, skewX:0, x:0}, .1, 0.2);
      tl.fromTo(total, .8, {opacity:0, x:-80}, {opacity:1, x:0}, 0.2);
      tl.fromTo(free_shipping, .8, {opacity:0, x:-80}, {opacity:1, x:0}, 0.3);
      tl.fromTo(buttons, .8, {opacity:0, x:-80}, {opacity:1, x:0}, 0.4);
      tl.fromTo(cart_empty_title, .8, {opacity:0, x:-80}, {opacity:1, x:0}, 0.2);
      tl.fromTo(cart_empty_buttons, .8, {opacity:0, x:-80}, {opacity:1, x:0}, 0.3);
    } else {
      tl.fromTo(widget_list, .5, {autoAlpha: 0}, {autoAlpha: 1, ease: Power4.easeIn}, .1);
      tl.staggerFromTo(widget_list_item, .5, {opacity:0, skewX:20, x:60}, {opacity:1, skewX:0, x:0}, .1, 0.2);
      tl.fromTo(total, .8, {opacity:0, x:80}, {opacity:1, x:0}, 0.2);
      tl.fromTo(free_shipping, .8, {opacity:0, x:80}, {opacity:1, x:0}, 0.3);
      tl.fromTo(buttons, .8, {opacity:0, x:80}, {opacity:1, x:0}, 0.4);
      tl.fromTo(cart_empty_title, .8, {opacity:0, x:80}, {opacity:1, x:0}, 0.2);
      tl.fromTo(cart_empty_buttons, .8, {opacity:0, x:80}, {opacity:1, x:0}, 0.3);			
    }
  }

  function open() {
    if ($(selectors.miniCart).length) {
      if ($(selectors.headerSticky).length && $(selectors.headerSticky).hasClass('stick')) {
        var that = $(selectors.headerSticky).find(selectors.headerCart);
        if (that.length) {
          var miniCart = that.closest('.header__cart').find(selectors.miniCart);
          if (miniCart.length && miniCart.hasClass('minicart-sidebar') && !miniCart.hasClass('opened')) {
            that.trigger('click');
            return false;
          }
        }
      }
      $(selectors.headerCart).each(function() {
        var that = $(this);
        if (that.is(":visible")) {
          var miniCart = that.closest('.header__cart').find(selectors.miniCart);
          if (miniCart.length && miniCart.hasClass('minicart-sidebar') && !miniCart.hasClass('opened')) {
            that.trigger('click');
            return false;
          }
        }
      });
    }
  }

  function update(product_id) {
    if (typeof product_id == "undefined") {
      product_id = 0;
    }
    $(selectors.miniCart).addClass('loading');

    return $.get('/search', function(response) {
      $(selectors.miniCart).each(function() {
        var that = $(this);
        var ext = '';
        
        if (that.hasClass('minicart-frame')) {
          ext = '.minicart-frame';
        }
        else if (that.hasClass('minicart-sidebar')) {
          ext = '.minicart-sidebar';
        }
        
        var minicart = $(response).find(selectors.miniCart + ext);
        that.removeClass('loading').html(minicart.html());
        
        var cart_link = that.prev();
        cart_link.html(minicart.prev().html());
        cart_link.addClass('anim');
        setTimeout(function() { 
          cart_link.removeClass('anim');
        }, 2000);
      });

      if (product_id > 0) {
        var product_class = '.product__' + product_id;
        $(product_class + ' .addcart_btn').removeClass('added');
      }
    });
  }

  function headerCart() {
    // header cart click
    $(document).off('click', selectors.headerCart);
    $(document).on('click', selectors.headerCart, function(evt) {
      var that = $(this);
      var minicart = that.parent().find(selectors.miniCart);

      if (minicart.length) {
        
        if (minicart.hasClass('minicart-sidebar')) {
          $(selectors.miniCart).each(function() {
            if (minicart.attr('id') != $(this).attr('id')) {
              $(this).removeClass('opened');
            }
          });

          if (minicart.hasClass('opened')) {
            minicart.removeClass('opened');

          }
          else {
            minicart.addClass('opened');
            $('body').addClass('cart-opened');
            theme.MiniCart.anim();
          }
          
          evt.preventDefault();
        }
      }
    });
  }

  function cartCheckout() {
    // mini cart agree click
    $(document).off('change', selectors.miniCartAgree);
    $(document).on('change', selectors.miniCartAgree, function(evt) {
      var agree = $(this);

      if (agree.is(':checked')) {
        $(selectors.miniCartAgree).prop('checked', true);
        $(selectors.miniCartCheckout).removeClass('btn-disabled');
      }
      else {
        $(selectors.miniCartAgree).prop('checked', false);
        $(selectors.miniCartCheckout).addClass('btn-disabled');
      }
    });

    // mini cart checkout click
    $(document).off('click', selectors.miniCartCheckout);
    $(document).on('click', selectors.miniCartCheckout, function(evt) {
      if ($(selectors.miniCartAgree).length) {

        var agree = $(selectors.miniCartAgree);
        if (!agree.is(':checked')) {
          var message = agree.data('message');
          alert(message);

          evt.preventDefault();
        }
      }
    });
  }

  function cartRemove() {
    // mini cart remove click
    $(document).off('click', selectors.miniCartRemove);
    $(document).on('click', selectors.miniCartRemove, function(evt) {
      evt.preventDefault();

      var that = $(this);
      var url = that.attr('href');
      var product_id = that.data('product_id');

      $(selectors.miniCart).addClass('loading');
      $.post(url, function() {
        update(product_id);
      });
    });
  }

  function cartClose() {
    // mini cart close
    $(document).off('click', selectors.miniCartClose);
    $(document).on('click', selectors.miniCartClose, function() {
      $(selectors.miniCart).removeClass('loading').removeClass('opened');
      $('body').removeClass('cart-opened');
    });
  }

  function cartUpdate(cart, form) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      async: !0,
      cache: !1,
      data: form.serialize(),
      dataType: 'json',
      beforeSend: function() {
        cart.addClass('loading');
      },
      success: function(response) {
        // cart.removeClass('loading');
        update();
      }
    });
  }

  function cartQty() {
    // mini cart qty click
    $(document).off('click', selectors.miniCartQty + ' .plus');
    $(document).on('click', selectors.miniCartQty + ' .plus', function() {
      var parent = $(this).parent();
      var quantity = parent.find('.qty');

      var qty = parseInt(quantity.val());
      qty = qty + 1;
      quantity.val(qty).trigger('change');
    });

    $(document).off('click', selectors.miniCartQty + ' .minus');
    $(document).on('click', selectors.miniCartQty + ' .minus', function() {
      var parent = $(this).parent();
      var quantity = parent.find('.qty');

      var qty = parseInt(quantity.val());
      if (qty > 1) {
        qty = qty - 1;
        quantity.val(qty).trigger('change');
      }
    });

    $(document).off('change', selectors.miniCartQty + ' .qty');
    $(document).on('change', selectors.miniCartQty + ' .qty', function() {
      var form = $(this).closest('form');
      var cart = $(this).closest('.minicart');
      cartUpdate(cart, form);
    });
  }

  function init(){
    headerCart();
    cartCheckout();
    cartRemove();
    cartClose();
    cartQty();
  }

  return {
    init: init,
    update: update,
    open: open,
    anim: anim
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr('data-section-id'));
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
    /*
    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    */
    
    this.beforeInit(slideshow);
    this.init();
  }
  
  SlideshowSection.prototype = _.assignIn({}, SlideshowSection.prototype, {
    
    beforeInit: function(slider) {
     
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      var vh = window.innerHeight * 0.01;

      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', vh +'px');

      // We listen to the resize event
      window.addEventListener('resize', function() {
        // We execute the same script as before
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh +'px');

        if($(slider).hasClass("slideshow--auto") && $(slider).find(".slideshow__slide.is-selected .slideshow__image_tag").length > 0) {
          var slide_height = $(slider).find(".slideshow__slide.is-selected .slideshow__image_tag").height();
          $(slider).find(".flickity-viewport").css("height", slide_height + "px");
        }
      });
    },
    
    init: function() {
      var self = this;
      
      var carousel = $(self.slideshow),
          slider_autoplay = carousel.data("autoplay"),
          slider_autoplay_speed = carousel.data("speed"),
          slides = carousel.find('.slideshow__image');

      var flkty = new Flickity(self.slideshow, {
        rightToLeft: theme.settings.rtl,
        bgLazyLoad: 1,
        imagesLoaded: true,
        accessibility: true,
        prevNextButtons: true,
        pageDots: true,
        contain: true,
        wrapAround: true,     
        setGallerySize: false,
        autoPlay: slider_autoplay ? slider_autoplay_speed : false,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15
        },
        on: {
          ready: function() {
            if (carousel.hasClass("slideshow--auto") && carousel.find(".slideshow__slide.is-selected .slideshow__image_tag").length > 0) {
              var slide_height = carousel.find(".slideshow__slide.is-selected .slideshow__image_tag").height();
              carousel.find(".flickity-viewport").css("height", slide_height + "px");
            }

            if (theme.settings.animation) {
              var tl = new TimelineLite(),
                  slider_wrapper = carousel.find('.flickity-slider'),
                  slider_content = carousel.find('.slider-content-wrapper'),
                  slider_arrows = carousel.find('.flickity-button svg'),
                  slider_dots = carousel.find('.flickity-page-dots');

              tl.fromTo(slider_wrapper, 2, {scale:1.2}, {ease: Power4.easeInOut, scale:1}, 0);
              tl.fromTo(slider_content, 2.4, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1); 
              tl.fromTo([slider_arrows,slider_dots], 2, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1.3);
            }
          },
          change: function(index){
            if ($(carousel.find(".slideshow__slide")[index]).length > 0) {
              var slide_height = $(carousel.find(".slideshow__slide")[index]).find(".slideshow__image_tag").height();
              carousel.find(".flickity-viewport").css("height", slide_height + "px");
            }
            if ($(carousel.find(".slideshow__slide")[index]).hasClass("slideshow__video_background")) {
              var PlayerId = "SlideshowVideo-" + $(carousel.find(".slideshow__slide")[index]).data("block_id");
              if($("#" + PlayerId).length > 0){
                theme.SlideshowVideo.playVideo(PlayerId);
              }
            }
            else {
              carousel.find(".slideshow__video_item").length > 0 && carousel.find(".slideshow__video_item").each(function(e) {
                var PlayerId = "SlideshowVideo-" + $(this).data("block_id");
                if($("#" + PlayerId).length > 0){
                  theme.SlideshowVideo.pauseVideo(PlayerId);
                }
              })
            }
          }
          
        }      
      });
      
      flkty.on('scroll', function () {
        flkty.slides.forEach(function (slide, i) {
          var image = slides[i],    
              x = 0;

          if (image) {
            if( 0 === i ) {
              x = Math.abs( flkty.x ) > flkty.slidesWidth ? ( flkty.slidesWidth + flkty.x + flkty.slides[flkty.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flkty.x );
            } else if( i === flkty.slides.length - 1 ) {
              x = Math.abs( flkty.x ) + flkty.slides[i].outerWidth < flkty.slidesWidth ? ( slide.target - flkty.slidesWidth + flkty.x - flkty.slides[i].outerWidth ) : ( slide.target + flkty.x );
            } else {
              x = slide.target + flkty.x;
            }

            if (typeof window.mobileCheck != 'undefined' && !window.mobileCheck() && !theme.settings.rtl) {
              image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
            }
          }
        });
      });
    },
    
    onSelect: function() {
      if (typeof theme.roarAdminJs != 'undefined') {
        theme.roarAdminJs.refresh();
      }
    },
    
    /*
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
    */
  });

  return SlideshowSection;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    var arrows = this.$slideshow.data('arrows') || false;
    var dots = this.$slideshow.data('dots') || false;
    var autoplay = this.$slideshow.data('autoplay') || false;
    var speed = parseInt(this.$slideshow.data('speed')) || 7000;
    var per_view = parseInt(this.$slideshow.data('per_view')) || 1;

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      arrows: arrows,
      dots: dots,
      autoplay: autoplay,
      speed: speed,
      per_view: per_view,
      sliderImagesActive: false,
    };

    this.initBreakpoints();
  }

  slideshow.prototype = _.assignIn({}, slideshow.prototype, {
    initBreakpoints: function() {
      var self = this;

      enquire.register(self.settings.mediaQuerySmall, {
        match: function() {
          if (self.settings.sliderImagesActive) {
            self.destroyImageSlider();
          }
          self.initImageSlider();
        }
      });

      enquire.register(self.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.sliderImagesActive) {
            self.destroyImageSlider();
          }
          self.initImageSlider(false);
        }
      });
    },
    destroyImageSlider: function() {
      $(this.$slideshow).slick('unslick');
      this.settings.sliderImagesActive = false;
    },
    initImageSlider: function(mobile) {
      if (typeof mobile == "undefined") {
        mobile = true;
      }
      var options = {
        rtl: theme.settings.rtl,
        accessibility: true,
        arrows: this.settings.arrows,
        dots: this.settings.dots,
        fade: this.settings.per_view ? false : true,
        speed: 1000,
        delay: 1600,
        draggable: true,
        autoplay: this.settings.autoplay,
        autoplaySpeed: this.settings.speed,
        slidesToShow: this.settings.per_view,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-prev"></use></svg></button>',
        nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-next"></use></svg></button>',
      };
      if (mobile == true) {
        options.fade = false;
        options.draggable = true;
        options.slidesToShow = 1;
        options.arrows = false;
        options.dots = true;
      }
      
      this.$slideshow.on('beforeChange', beforeChange.bind(this));
      this.$slideshow.on('afterChange', afterChange.bind(this));
      this.$slideshow.on('init', slideshowA11y.bind(this));
      
      this.$slideshow.slick(options);
      this.$pause.on('click', this.togglePause.bind(this));
      this.settings.sliderImagesActive = true;
    },
    togglePause: function() {
      var slideshowSelector = getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    }
  });

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
    
    // Animate
    $slider.find('.' + classes.currentSlide).addClass('slick-anim');
    
    var tl = new TimelineLite(),
        slider_wrapper = $slider,
        slider_content = $slider.find('.slideshow__text-text'),
        slider_arrows = $slider.find('.slick-arrow svg'),
        slider_dots = $slider.find('.slick-dots');

    tl.fromTo(slider_wrapper, 2, {scale:1.2}, {ease: Power4.easeInOut, scale:1}, 0);
    tl.fromTo(slider_content, 2.4, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1);
    tl.fromTo([slider_arrows,slider_dots], 2, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1.3);
  }

  function beforeChange(event, slick, currentSlide, nextSlide, targetSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slick-slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
    
    // Animation
    $currentSlide.removeClass('slick-anim');
    $slider.find('.slick-slide[data-slick-index="' + targetSlide + '"]').addClass('slick-anim');
    $slider.find('.slick-arrow').addClass('disabled');
  }
  
  function afterChange(event, slick, currentSlide) {
    slick.$slider.find('.slick-arrow').removeClass('disabled');
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickSlide: 'slick-slide',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
    .then(function() {
      setAutoplaySupport(true);
    })
    .fail(function() {
      // No autoplay available (or took too long to start playing).
      // Show fallback image. Stop video for safety.
      setAutoplaySupport(false);
      player.stopVideo();
    })
    .always(function() {
      autoplayCheckComplete = true;
      $slide.removeClass(classes.loading);
    });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (typeof window.mobileCheck != 'undefined' && window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.closest('.' + classes.slickSlide).hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id;
    return videos[id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
      .width(playerWidth)
      .height(playerHeight)
      .css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
      .width(slideWidth)
      .height(playerHeight)
      .css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
    .removeAttr('style')
    .removeClass(classes.videoBackground)
    .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].$parentSlide
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
    .addClass(classes.videoBackground)
    .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $(document).off('click', '#RecoverPassword');
    $(document).on('click', '#RecoverPassword', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $(document).off('click', '#HideRecoverPasswordLink');
    $(document).on('click', '#HideRecoverPasswordLink', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
theme.Cart = (function() {

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      namespace: '#CartSection-' + sectionId,
      sectionId: sectionId,
    };

    this.selectors = {
      quantity: '.item__qty-' + sectionId,
      agree: '#cart__agree-' + sectionId,
      checkout: '.cart__checkout-' + sectionId + ' [name="checkout"], .cart__checkout-' + sectionId + ' [name="goto_pp"], .cart__checkout-' + sectionId + ' [name="goto_gc"]',
      remove: '.item__remove-' + sectionId,
      update: '.cart__update-' + sectionId,
    };

    this._qtyCart();
    this._checkoutCart();
    this._removeCart();
    this._updateCart();
    this._productsSlider();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {

    _removeCart: function() {
      var self = this;

      $(document).off('click', self.selectors.remove);
      $(document).on('click', self.selectors.remove, function(evt) {
        evt.preventDefault();

        var that = $(this);
        var url = that.attr('href');
        var cart = $(self.settings.namespace);
        cart.addClass('loading');

        $.post(url, function() {
          $.get('/cart?view=popup', function(response) {
            cart.html($(response).find(self.settings.namespace).html());
            setTimeout(function() {
              cart.removeClass('loading');
              
              theme.MiniCart.update();

              var sections = new theme.Sections();
              sections.register('cart-gift-popup', theme.CartGift);
              sections.register('shipping-calculator-popup', theme.ShippingCalculator);
            }, 100);
          });
        });
      });
    },

    _updateCart: function() {
      var self = this;

      $(document).off('click', self.selectors.update);
      $(document).on('click', self.selectors.update, function(evt) {
        evt.preventDefault();

        var form = $(this).closest('form');
        var cart = $(self.settings.namespace);

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          async: !0,
          cache: !1,
          data: form.serialize(),
          dataType: 'json',
          beforeSend: function() {
            cart.addClass('loading');
          },
          success: function(response) {
            $.get('/cart?view=popup', function(response) {
              cart.html($(response).find(self.settings.namespace).html());
              setTimeout(function() {
                cart.removeClass('loading');
                
                theme.MiniCart.update();
                
                var sections = new theme.Sections();
                sections.register('cart-gift-popup', theme.CartGift);
                sections.register('shipping-calculator-popup', theme.ShippingCalculator);
              }, 100);
            });
          }
        });
        return false;
      });
    },

    _qtyCart: function() {
      var self = this;

      $(document).off('click', self.selectors.quantity + ' .plus');
      $(document).on('click', self.selectors.quantity + ' .plus', function() {
        var parent = $(this).parent();
        var quantity = parent.find('.qty');

        var qty = parseInt(quantity.val());
        qty = qty + 1;
        quantity.val(qty);
      });

      $(document).off('click', self.selectors.quantity + ' .minus');
      $(document).on('click', self.selectors.quantity + ' .minus', function() {
        var parent = $(this).parent();
        var quantity = parent.find('.qty');

        var qty = parseInt(quantity.val());
        if (qty > 0) {
          qty = qty - 1;
          quantity.val(qty);
        }
      });
    },

    _checkoutCart: function() {
      var self = this;
      
      if (!$(self.selectors.agree).length) {
        return;
      }

      $(document).off('click', self.selectors.checkout);
      $(document).on('click', self.selectors.checkout, function() {
        if ($(self.selectors.agree).length) {
          var that = $(this);
          var agree = $(self.selectors.agree);
          if (agree.is(':checked')) {
            that.submit();
          }
          else {
            var message = agree.data('message');
            alert(message);
            return false;
          }
        }
      });

      $(document).on('change', self.selectors.agree, function(evt) {
        var agree = $(this);

        if (agree.is(':checked')) {
          $(self.selectors.checkout).removeClass('btn-disabled');
        }
        else {
          $(self.selectors.checkout).addClass('btn-disabled');
        }
      });
    },
    
    _productsSlider: function() {
      var sections = new theme.Sections();
      sections.register('products-slider-sub', theme.ProductsSlider);
    },

    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },

    onLoad: function() {
      this._lineItem();
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return Cart;
})();

theme.ShippingCalculator = (function() {
  function ShippingCalculator(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      shipping_btn: '#cart__shipping-btn-' + sectionId,
      shipping_calculator: '#shipping__calculator-' + sectionId,
      get_rates: '#shipping__calculator-btn-' + sectionId,
      response: '#shipping__calculator-response-' + sectionId,
      template: '<p id ="shipping-rates-feedback-' + sectionId + '" class="shipping-rates-feedback"></p>',
      address_country: 'address_country-' + sectionId,
      address_province: 'address_province-' + sectionId,
      address_zip: 'address_zip-' + sectionId,
      address_province_label: 'address_province_label-' + sectionId,
      address_province_container: 'address_province_container-' + sectionId,
    };

    this.strings = {
      submitButton: theme.strings.shippingButton, 
      submitButtonDisabled: theme.strings.shippingButtonDisabled,
      customerIsLoggedIn: theme.settings.customerIsLoggedIn,
      moneyFormat: theme.settings.moneyFormat
    };

    this._init();
  }

  ShippingCalculator.prototype = _.assignIn({}, ShippingCalculator.prototype, {

    _disableButtons: function() {
      var selectors = this.selectors;
      var strings = this.strings;

      $(selectors.get_rates).text(strings.submitButtonDisabled).attr('disabled', 'disabled').addClass('disabled');
    },

    _enableButtons: function() {
      var selectors = this.selectors;
      var strings = this.strings;

      $(selectors.get_rates).removeAttr('disabled').removeClass('disabled').text(strings.submitButton);
    },

    _render: function(response) {
      var selectors = this.selectors;
      var strings = this.strings;

      var template = $(selectors.template);
      var wrapper = $(selectors.response);

      if (wrapper.length) {
        if (response.success) {
          template.addClass('success');

          if (response.rates) {
            template.append(response.rates);

            var rates = response.rates;
            if (rates[0]) {
              var rate = rates[0];

              template.append('Rates start at <span class="money">' + rate.price + '</span>.');
            }
          }
          else {
            template.append('We do not ship to this destination.');
          }
        }
        else {
          template.addClass('error');
          template.append(response.errorFeedback);
        }
        template.appendTo(wrapper);
      }
    },

    _formatRate: function(cents) {
      var selectors = this.selectors;
      var strings = this.strings;

      if (typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, strings.moneyFormat);
      }    
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = strings.moneyFormat;

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number/100.0).toFixed(precision);
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    },

    _onCartShippingRatesUpdate: function(rates, shipping_address ) {
      var self = this;
      var selectors = this.selectors;
      var strings = this.strings;

      // Re-enable calculate shipping buttons.
      self._enableButtons();

      // Formatting shipping address.
      var readable_address = '';
      if (shipping_address.zip) {
        readable_address += shipping_address.zip + ', ';
      }
      if (shipping_address.province) {
        readable_address += shipping_address.province + ', ';
      }
      readable_address += shipping_address.country;

      // Show estimated shipping.
      if (rates.length) {
        for (var i=0; i < rates.length; i++) {
          rates[i].price = self._formatRate(rates[i].price);
        }
      }

      // Show rates and feedback.
      self._render({rates: rates, address: readable_address, success:true});

      // Revealing response.
      $(selectors.response).fadeIn();
    },

    _pollForCartShippingRatesForDestination: function(shippingAddress) {
      var self = this;
      var selectors = this.selectors;
      var strings = this.strings;

      var poller = function() {
        $.ajax('/cart/async_shipping_rates', {
          dataType: 'json',
          success: function(response, textStatus, xhr) {
            if (xhr.status === 200) {
              self._onCartShippingRatesUpdate(response.shipping_rates, shippingAddress)
            } else {
              setTimeout(poller, 500)
            }
          },
          error: function(XMLHttpRequest, textStatus) {
            self._onError(XMLHttpRequest, textStatus, self);
          }
        })
      }
      return poller;
    },

    _fullMessagesFromErrors: function(errors) {
      var selectors = this.selectors;
      var strings = this.strings;

      var fullMessages = [];
      $.each(errors, function(attribute, messages) {
        $.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    },

    _onError: function(XMLHttpRequest, textStatus, self) {
      var selectors = self.selectors;
      var strings = self.strings;

      // Re-enable calculate shipping buttons.
      self._enableButtons();

      // Formatting error message.
      var feedback = '';
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        feedback = data.message + '(' + data.status  + '): ' + data.description;
      } 
      else {
        feedback = 'Error : ' + self._fullMessagesFromErrors(data).join('; ') + '.';
      }    
      if (feedback === 'Error : country is not supported.') {
        feedback = 'We do not ship to this destination.'
      }

      // Update calculator.
      self._render({rates: [], errorFeedback: feedback, success: false});
      $(selectors.response).show();
    },

    _getCartShippingRatesForDestination: function(shippingAddress) {
      var self = this;
      var selectors = this.selectors;
      var strings = this.strings;

      $.ajax({
        type: 'POST',
        url: '/cart/prepare_shipping_rates',
        data: $.param({'shipping_address': shippingAddress}),
        success: self._pollForCartShippingRatesForDestination(shippingAddress),
        error: function(XMLHttpRequest, textStatus) {
          self._onError(XMLHttpRequest, textStatus, self);
        }
      });
    },

    _init: function() {
      var self = this;
      var selectors = this.selectors;
      var strings = this.strings;

      if (!$(selectors.shipping_calculator).length) {
        return;
      }

      // Initialize observer on shipping address.
      new Shopify.CountryProvinceSelector(selectors.address_country, selectors.address_province, {hideElement: selectors.address_province_container});

      // Updating province label.
      var countriesSelect = $('#' + selectors.address_country);
      var addressProvinceLabelEl = $('#' + selectors.address_province_label).get(0);
      if (typeof Countries !== 'undefined') {
        Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl);
        countriesSelect.change(function() {
          Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl);
        });
      }

      // When either of the calculator buttons is clicked, get rates.
      $(selectors.get_rates).off('click');
      $(selectors.get_rates).click(function() {
        // Disabling all buttons.
        self._disableButtons();

        // Hiding response.
        $(selectors.response).empty().hide();

        // Reading shipping address for submission.
        var shippingAddress = {};
        shippingAddress.zip = $('#' + selectors.address_zip).val() || '';
        shippingAddress.country = $('#' + selectors.address_country).val() || '';
        shippingAddress.province = $('#' + selectors.address_province).val() || '';
        self._getCartShippingRatesForDestination(shippingAddress);
      });

      // We don't wait for customer to click if we know his/her address.
      if (strings.customerIsLoggedIn) {
        $(selectors.get_rates + ':eq(0)').trigger('click');
      }

      // Click shipping button
      $(selectors.shipping_btn).off('click');
      $(selectors.shipping_btn).click(function() {
        $(selectors.shipping_calculator).slideToggle();
      });
    }
  });

  return ShippingCalculator;
})();

theme.CartGift = (function() {
  function CartGift(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      gift: '#gift__wrapping-' + sectionId,
      namespace: '#CartSection-' + sectionId,
      redirect: true
    };

    this.init();
  }

  CartGift.prototype = _.assignIn({}, CartGift.prototype, {

    check: function() {
      var self = this;
      var selectors = this.selectors;
      
      if (!$(selectors.gift).length) {
        return;
      }

      var gift_case = $(selectors.gift).data('gift_case');
      switch(gift_case) {
        case 1:
          self.remove();
          break;
        case 2:
          self.set();
          break;
        case 3:
          self.set();
          break;
        case 3:
          self.set();
          break;
      }
    },

    set: function() {
      var self = this;
      var selectors = this.selectors;
      
      if (!$(selectors.gift).length) {
        return;
      }

      var id = $(selectors.gift).data('product_id');

      var updates = new Object();
      updates[id] = 1;

      var attributes = new Object();
      attributes['gift-wrapping'] = true;

      var data = new Object();
      data['updates'] = updates;
      data['attributes'] = attributes;

      $.ajax({
        type: 'POST',
        url: '/cart/update.js', 
        data: data,
        dataType: 'json',
        beforeSend: function() {
          if (!selectors.redirect) {
            $(selectors.namespace).addClass('loading');
          }
        },
        success: function() {
          if (selectors.redirect) {
            location.href = '/cart';
          }
          else {
            var cart = $(selectors.namespace);

            $.get('/cart?view=popup', function(response) {
              cart.html($(response).find(selectors.namespace).html());
              setTimeout(function() {
                cart.removeClass('loading');
                
                theme.MiniCart.update();
                
                var sections = new theme.Sections();
                sections.register('shipping-calculator-popup', theme.ShippingCalculator);
              }, 100);
            });
          }
        }
      });
    },

    remove: function() {
      var self = this;
      var selectors = this.selectors;
      
      if (!$(selectors.gift).length) {
        return;
      }

      var id = $(selectors.gift).data('product_id');

      var updates = new Object();
      updates[id] = 0;

      var attributes = new Object();
      attributes['gift-wrapping'] = '';

      var data = new Object();
      data['updates'] = updates;
      data['attributes'] = attributes;

      $.ajax({
        type: 'POST',
        url: '/cart/update.js', 
        data: data,
        dataType: 'json',
        beforeSend: function() {
          if (!selectors.redirect) {
            $(selectors.namespace).addClass('loading');
          }
        },
        success: function() {
          if (selectors.redirect) {
            location.href = '/cart';
          }
          else {
            var cart = $(selectors.namespace);

            $.get('/cart?view=popup', function(response) {
              cart.html($(response).find(selectors.namespace).html());
              setTimeout(function() {
                cart.removeClass('loading');
                
                theme.MiniCart.update();
                
                var sections = new theme.Sections();
                sections.register('shipping-calculator-popup', theme.ShippingCalculator);
              }, 100);
            });
          }
        }
      });
    },

    init: function() {
      var self = this;
      var selectors = this.selectors;
      
      if (!$(selectors.gift).length) {
        return;
      }

      if ($(selectors.gift).data('redirect') == false) {
        this.selectors.redirect = false;
      }

      self.check();

      $(document).off('change', selectors.gift);
      $(document).on('change', selectors.gift, function() {
        if ($(this).is(':checked')) {
          self.set();
        }
        else {
          self.remove();
        }
      });
    }
  });

  return CartGift;
})();

theme.Filters = (function() {
  var selectors = {
    filterForm: '#CollectionFiltersForm',

    filterChoice: '[data-filter-choice]',

    tagChoice: '[data-tag-choice]',
    tagClear: '[data-filter-clear]',

    sortSelection: '#SortBy',
    limitSelection: '#limit',
    layoutChoice: '[data-layout]',

    pageSelection: '#site-pagination a.btn',
    loadMoreSelection: '#site-pagination .loadmore',
    filtersSelection: '.sidebar__btn'
  }, 

  attributes = {
      filterChoices: 'data-filter-choice',
      tagChoices: 'data-tag-choice'
  };
  
  function beforeInit() {
    if (!$(selectors.filter).length) {
      return;
    }
  }

  function Filters(container) {

    console.log('filter is here');
    this.$containerElement = $(container);
    this.$container = container;
    this._refresh();
  
    beforeInit();

    $(document).on('change', selectors.sortSelection, this._onSortChangeAjax.bind(this));
    $(document).on('change', selectors.limitSelection, this._onLimitChangeAjax.bind(this));
    $(document).on('input', selectors.filterForm , this._onFilterFormChangeAjax.bind(this));
    $(document).on('click', selectors.tagChoice , this._onTagChoiceChangeAjax.bind(this));
    $(document).on('click', selectors.layoutChoice , this._onLayoutChangeAjax.bind(this));
    $(document).on('click', selectors.tagClear , this._onTagClearChangeAjax.bind(this));


    $(document).on('click', selectors.pageSelection, this._onPageClick.bind(this));
    $(document).on('click', selectors.loadMoreSelection, this._onLoadMoreClick.bind(this));
    this._initParams();
    this._onLoadMoreInfinite(selectors.loadMoreSelection);
    this._initFiltersActive();
    
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {

    _initFiltersHtml: function() {
      if ($('.shop__filtering').length) {
        if($(selectors.filterForm).length > 0){
          $(selectors.filterForm).prependTo(".shop__filtering-inner");
          $(selectors.filterForm).addClass('widget-area');
        }else{
          $('.shop__filtering-inner').empty().append($('.site-sidebar').html());
        }
      }
    },
    
    _initFiltersActive: function() {
      if ($('.filters__active .clear_nav').find('label').length) {
        $('.filters__active').show();
      }
      if( $(selectors.filterForm).length > 0) return;
      if ($('.filters__active').length > 0) {
        var clear_nav = $('.filters__active .clear_nav').empty();
        
        $('.site-widget.filtering').each(function() {
          var that = $(this);

          if (that.find('.filter-tag.active').length) {
            var tag = that.find('.filter-tag.active label').clone();
            clear_nav.append(tag);
          }
          else if (that.find('.filter-tag select').length && that.find('.filter-tag select').val() != '') {
            var tag = '<label for="'+ that.find('.filter-tag input').attr('id') +'">'+ that.find('.filter-tag select').val() +'</label>';
            clear_nav.append(tag);
          }
        });
        
        if (clear_nav.find('label').length) {
          $('.filters__active').show();
        }
        else {
          $('.filters__active').hide();
        }
      }
    },

    _initParams: function() {
      console.log('init-param');
      this.queryParams = new FormData();
      if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                  this.queryParams.append(decodeURIComponent(aKeyValue[0]), decodeURIComponent(aKeyValue[1]));
              }
          }
      }
    },
    _refresh: function() {

        this.collectionHandle = this.$container.dataset.collectionHandle;
        this.currentTags = this.$container.dataset.currentTags;
        
        this.containerSelect = '#' + this.$container.id;
        this.filterChoices = this.$container.querySelectorAll(selectors.filterChoice);
        this.tagChoices = this.$container.querySelectorAll(selectors.tagChoice);

        this.sortSelect = this.$container.querySelector(selectors.sortSelection);
        this.limitSelect = this.$container.querySelector(selectors.limitSelection);
        this.$limitSelect = $(selectors.limitSelection, this.$containerElement);
        this.$sortSelect = $(selectors.sortSelection, this.$containerElement);
    
        this.$selects = $(selectors.limitSelection, this.$containerElement).add(
          $(selectors.sortSelection, this.$containerElement)
        );
  
        this._resizeSelect(this.$selects);
        this.$selects.removeClass('hidden');

        this.filterChoicesAttr = attributes.filterChoices;
        this.tagChoicesAttr = attributes.tagChoices;

        if (this.sortSelect) {
            this.defaultSort = this._getDefaultSortValue();
        }

        if (this.limitSelect) {
            this.defaultLimit = this._getDefaultLimitValue();
        }
       
        this._initFiltersHtml();
        this._priceSlider('.filter-price-slider');
    },
    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },
    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },
    _getLimitValue: function() {
        return this.limitSelect.value || this.defaultLimit;
    },
    _getDefaultLimitValue: function() {
        return this.limitSelect.dataset.defaultLimit;
    },

    _priceSlider: function ( selector, option ) {
      if(document.querySelector('.filter-price-slider') == undefined ) return;
      var _rmin = parseInt(document.querySelector(selector).dataset.rangemin, 10);
      var _rmax = parseInt(document.querySelector(selector).dataset.rangemax, 10);
      var _cmin = parseInt(document.querySelector(selector).dataset.currmin, 10);
      var _cmax = parseInt(document.querySelector(selector).dataset.currmax, 10);
      if ( typeof noUiSlider === 'object' ) {
          $( selector ).each( function () {
              var self = this;

              noUiSlider.create( self, $.extend( true, {
                  start: [ _cmin, _cmax ],
                  connect: true,
                  step: 1,
                  range: {
                      min: _rmin,
                      max: _rmax
                  }
              }, option ) );

              var handles = self.querySelectorAll('.noUi-handle');
              if (handles.length >= 2) {
                  handles[0].setAttribute('aria-label', 'Minimum price');
                  handles[1].setAttribute('aria-label', 'Maximum price');
              }

              self.noUiSlider.on( 'update', function ( values, handle ) {
                  var values = values.map( function ( value ) {
                      return '$' + parseInt( value );
                  } )
                  $( self ).parent().find( '.filter-price-range' ).text( values.join( ' - ' ) );
              } );
              self.noUiSlider.on( 'end', function ( values, handle ) {
                  var _min = parseInt( values[0] );
                  var _max = parseInt( values[1] );
                  $( self ).parent().find( '.filter-price--min' ).val(_min);
                  $( self ).parent().find( '.filter-price--max' ).val(_max);
              } );
              $( self ).parent().find( '.price-filter-action' ).on( 'click', function(){
                  var _event = new Event('input', {
                      bubbles: true,
                      cancelable: true,
                  });
                  document.querySelector(selector).closest( 'form' ).dispatchEvent(_event);
              });
          } );
      }
    },
    
    _onSortChangeAjax: function() {
      this.queryParams.set('sort_by', this._getSortValue());
      this.queryParams.delete('page');

      var new_url = window.location.origin + window.location.pathname + '?' + decodeURIComponent(
          new URLSearchParams(this.queryParams).toString()
      );
      this._ajaxCall(new_url);
    },
    _onLimitChangeAjax: function() {
        this.queryParams.set('limit', this._getLimitValue());
        this.queryParams.delete('page');

        var new_url = window.location.origin + window.location.pathname + '?' + decodeURIComponent(
            new URLSearchParams(this.queryParams).toString()
        );
        this._ajaxCall(new_url);
    },

    _onTagClearChangeAjax: function(evt){

      var currentTags = this.$container.dataset.currentTags;
      var currentTagsArray = currentTags.split(',');

      var site_widget = $(evt.target).closest('.site-widget.filtering');
      var dropdown = site_widget.find('select');
      if (dropdown.length > 0) {
        dropdown.find('option').each(function() {

          var tagName = $(this).val();
          if (tagName) {

            var tagPos = currentTagsArray.indexOf(tagName);
            if (tagPos >= 0) {
              // remove tag
              currentTagsArray.splice(tagPos, 1);
            }
          }
        });
      }

      var otherTags = site_widget.find('input');
      if (otherTags.length > 0) {
        otherTags.each(function() {
          var tagName = $(this).val();

          if (tagName) {
            var tagPos = currentTagsArray.indexOf(tagName);

            if (tagPos >= 0) {
              // remove tag
              currentTagsArray.splice(tagPos, 1);
            }
          }
        });
      }

      var filter_tags = "";
      var newTagsArray =  currentTagsArray.filter((v) => v != '');
      var newCurrentsTags = "";
      if (newTagsArray.length > 0){
        filter_tags = newTagsArray.join('+');
        var newCurrentsTags = ',' + newTagsArray.join(',') + ',';
      }

      // return current new tags
      this.$container.dataset.currentTags = newCurrentsTags;

      var defaultHref = '/collections/' + this.collectionHandle;

      if(filter_tags != "") {
        defaultHref = defaultHref + '/' + filter_tags;
      }
      this.queryParams.delete('page');

      var valid_params = [ "view", "limit", "sort_by", "lo", "token"];
      var toberemoved_params = [];
      for(var pair of this.queryParams.entries()) {
          if(valid_params.indexOf(pair[0]) <= 0) {
              toberemoved_params.push(pair[0]);
          }
      }
      toberemoved_params.forEach(el => this.queryParams.delete(el));
      var queryString = decodeURIComponent(
          new URLSearchParams(this.queryParams).toString()
      );
      var new_url = defaultHref + '?' + queryString;
      this._ajaxCall(new_url);

    },
    _onTagChoiceChangeAjax: function(evt){

      var that = $(evt.currentTarget);
      var advanced_filter = that.closest('.advanced-filter');
      var filter_tag = that.closest('.filter-tag');
      var multi_choice = advanced_filter.data('multi_choice');

      var currentTags = this.$container.dataset.currentTags;
      var tag_element = evt.target.closest(selectors.tagChoice);
      var data_tag = ','+tag_element.value+',';
      var currentTagsArray = currentTags.split(',');


      // one selection or multi selection
      if (multi_choice == false && !filter_tag.hasClass('active')) {
        // remove other selection first
        var otherTags = advanced_filter.find('.active input');
        if (otherTags.length > 0) {

          otherTags.each(function() {

            var tagName = $(this).val();
            if (tagName) {

              var tagPos = currentTagsArray.indexOf(tagName);
              if (tagPos >= 0) {
                // remove tag
                currentTagsArray.splice(tagPos, 1);
              }
            }
          });
        }
      }

      // has dropdown selection
      var dropdown = advanced_filter.find('select');
      if (dropdown.length > 0) {

        dropdown.find('option').each(function() {

          var tagName = $(this).val();
          if (tagName) {

            var tagPos = currentTagsArray.indexOf(tagName);
            if (tagPos >= 0) {
              // remove tag
              currentTagsArray.splice(tagPos, 1);
            }
          }
        });
      }

      var tagName = that.val();
      if (tagName) {
        var tagPos = currentTagsArray.indexOf(tagName);
        if (tagPos >= 0) {
          // tag already existed, remove tag
          currentTagsArray.splice(tagPos, 1);
        }
        else {
          // tag not existed
          currentTagsArray.push(tagName);
        }
      }


      var filter_tags = "";
      var newTagsArray =  currentTagsArray.filter((v) => v != '');
      var newCurrentsTags = "";
      if (newTagsArray.length > 0){
        filter_tags = newTagsArray.join('+');
        var newCurrentsTags = ',' + newTagsArray.join(',') + ',';
      }
      // return current new tags
      this.$container.dataset.currentTags = newCurrentsTags;

      var defaultHref = '/collections/' + this.collectionHandle;

      if(filter_tags != "") {
        defaultHref = defaultHref + '/' + filter_tags;
      }

      this.queryParams.delete('page');

      var valid_params = [ "view", "limit", "sort_by", "lo", "token"];
      var toberemoved_params = [];
      for(var pair of this.queryParams.entries()) {
          if(valid_params.indexOf(pair[0]) <= 0) {
              toberemoved_params.push(pair[0]);
          }
      }
      toberemoved_params.forEach(el => this.queryParams.delete(el));
      var queryString = decodeURIComponent(
          new URLSearchParams(this.queryParams).toString()
      );
      var new_url = defaultHref + '?' + queryString;
      this._ajaxCall(new_url);
    
    },
    _onFilterFormChangeAjax: function(evt) {

      if(evt.target.classList.contains('widget__toggle')) {return}
    
      var currentTags = this.$container.dataset.currentTags;
      var currentTagsArray = currentTags.split(',');
      var newTagsArray =  currentTagsArray.filter((v) => v != '');

      var filter_tags = "";
      if (newTagsArray.length > 0){
        filter_tags = newTagsArray.join('+');
      }

      var defaultHref = '/collections/' + this.collectionHandle;

      if(filter_tags != "") {
        defaultHref = defaultHref + '/' + filter_tags;
      }
    
      var choice_ui = evt.target.closest(selectors.filterChoice);

      this.queryParams.delete('page');

      var valid_params = [ "view", "limit", "sort_by", "lo", "token"];
        var toberemoved_params = [];
        for(var pair of this.queryParams.entries()) {
            if(valid_params.indexOf(pair[0]) <= 0) {
                toberemoved_params.push(pair[0]);
            }
        }
        toberemoved_params.forEach(el => this.queryParams.delete(el));

        var filterFormData = new FormData(evt.target.closest('form'));
        for(var pair of filterFormData.entries()) {
            this.queryParams.append(pair[0], pair[1]);
        }
        var queryString = decodeURIComponent(
            new URLSearchParams(this.queryParams).toString()
        );
        /*
        if(choice_ui?.parentNode.tagName == 'LI') {
            choice_ui?.parentNode.classList.toggle('active');
        }
        */

        var new_url = defaultHref + '?' + queryString;
        this._ajaxCall(new_url);
    },
    _onLayoutChangeAjax: function(evt) {
      
      var choice = evt.target.closest(selectors.layoutChoice);
      if(choice.classList.contains('active')) return false;
      var views = $(selectors.layoutChoice);
      var view = choice.dataset.layout;
      if (view == 'grid') {
        view = view + '-' + choice.dataset.value;
      }
      this.queryParams.set('lo', view);
      this.queryParams.set('token', Math.floor(Math.random() * Math.floor(1000)));
      
      var new_url = window.location.origin + window.location.pathname + '?' + decodeURIComponent(
          new URLSearchParams(this.queryParams).toString()
      );
      this._ajaxCall(new_url);

      views.removeClass('active');
      choice.classList.add('active');

    },

    _ajaxCall: function(newurl, load_sb) {
      if (typeof load_sb == "undefined") {
        load_sb = true;
      }

      var products = '#site-primary .products';
      var no_products = '#site-primary .no-products';
      var product_found = '#site-primary .product-found';
      var product = '#site-primary .products .product';
      var pagination = '#site-pagination';
      var sidebar = '#site-secondary .site-sidebar';
      var filtering = '#site-primary .shop__filtering-inner';
      var _filter_actions = ".filter-actions-result";
      var that = this;

      $('body').removeClass('sidebar-open');
      $('.shop__filtering').slideUp();

      var ext = 40;
      if ($('#shopify-section-header-sticky').length && $('#shopify-section-header-sticky').is(':visible')) {
        ext = ext + $('#shopify-section-header-sticky').outerHeight();
      }
      else if ($('#shopify-section-header-mobile').length && $('#shopify-section-header-mobile').is(':visible')) {
        ext = ext + $('#shopify-section-header-mobile').outerHeight();
      }
      
      $('html, body').animate({
        scrollTop: $('#site-primary').offset().top - ext
      }, 1200);

      $.ajax({
        type: 'GET',
        url: newurl,
        beforeSend: function() {
          $('body').addClass('loading');
        },
        complete: function() {
          $('body').removeClass('loading');
        },
        success: function(response) {
          // destroy countdown
          if ($.fn.countdown) {
            $(products).find('.product__countdown .is-countdown').each(function() {
              $(this).countdown('destroy');
            });
          }

          $(pagination).empty().html($(response).find(pagination).html());
          if (load_sb) {
            $(sidebar).empty().html($(response).find(sidebar).html());
            
            if ($(filtering).length > 0) {
              $(filtering).empty().append($(response).find(filtering).html());
            }

            // $(filtering).empty().append($(sidebar).html());
            
            var sections = new theme.Sections();
            sections.register('sidebar-sticky', theme.SidebarSticky);
          }
          
          $(products).empty().attr('class', $(response).find(products).attr('class'));

          if ($(response).find(product).length > 0) {
            $(response).find(product).each(function() {
              $(products).append($(this));
            });
          }
          else {
            $(products).append($(response).find(no_products));
          }
          $(product_found).empty().html($(response).find(product_found).html());
          $(_filter_actions).empty().html($(response).find(_filter_actions).html());

          that._refresh();
          that._initFiltersActive();
          var title = $(response).filter('title').text();
          History.pushState({
            param: Shopify.queryParams
          }, title, newurl);
        }
      });
    },

    _onLoadMoreInfinite: function(selection) {
      var that = $(selection);
      var parent = that.closest('.ajax_load_button');
      var pagination = '#site-pagination';

      if (parent.hasClass('ajax_load_hidden')) {

        var products = '#site-primary .products';
        var buffer_pixels = Math.abs(0);

        $(window).scroll(function() {
          if ($(products).length && $(pagination).find('a.next').length) {

            var a = $(products).offset().top + $(products).outerHeight();
            var b = a - $(window).scrollTop();

            if ((b - buffer_pixels) < $(window).height()) {
              if (parseInt($(selection).attr('data-processing')) == 0) {
                $(selection).trigger('click');
              }
            }
          }
        });
      }
    },

    _onLoadMoreClick: function(evt) {
      evt.preventDefault();

      var _this = this;
      var that = '#site-pagination .loadmore';
      var parent = '#site-pagination .ajax_load_button';
      var product = '#site-primary .products .product';
      var pagination = '#site-pagination';
      
      if (parseInt($(that).attr('data-processing')) == 1) {
        return;
      }

      if ($(pagination).find('a.next').length) {
        $(that).attr('data-processing', 1);

        var url = $(pagination).find('a.next').attr('href');
        var no_more = $(that).data('no_more');

        $(parent).addClass('loading');

        $.get(url, function(response) {
          $(pagination).empty().html($(response).find(pagination).html());

          $(response).find(product).each(function() {
            $(product).last().after($(this));
          });

          $(parent).removeClass('loading');
          $(that).attr('data-processing', 0);

          if ($(pagination).find('a.next').length == 0) {
            $(parent).addClass('ajax_load_finished').removeClass('ajax_load_hidden');		                
            $(that).show().html(no_more).addClass('disabled').prop('disabled', true);
          }
        });
      }
      else {
        var no_more = $(that).attr('data-no-more');
        $(parent).addClass('ajax_load_finished').removeClass('ajax_load_hidden');		                
        $(that).show().html(no_more).addClass('disabled').prop('disabled', true);
      }
    },

    _onPageClick: function(evt) {
      evt.preventDefault();

      var that = $(evt.currentTarget);
      var url = that.attr('href');
      this._ajaxCall(url);
    },
    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 3;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    },
    onUnload: function() {

      if (this.sortSelect) {
        this.$sortSelect.off('change', this._onSortChangeAjax);
      }
      if (this.limitSelect) {
        this.$limitSelect.off('change', this._onLimitChangeAjax);
      }
    }
  });

  return Filters;
})();
theme.SidebarSticky = (function() {
  function SidebarSticky(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      selector: '#site-secondary .site-sidebar',
      primary: '#site-primary',
      toggle: '#site-secondary .site-widget__toggle'
    };

    this.init();
    this.update();
  }

  SidebarSticky.prototype = _.assignIn({}, SidebarSticky.prototype, {
    init: function(evt) {
      var $sidebar = $(this.settings.selector);

      if ($(window).width() < 992) {
        return;
      }

      var offset = 40,
          $primary = $(this.settings.primary);

      if( $('.site-header').hasClass('header-sticky')) {
        offset = 60;
      }

      var diff = $sidebar.outerHeight() - $primary.outerHeight();

      if(diff < -100) {
        $sidebar.stick_in_parent({
          offset_top: offset
        });
      }
      else if(diff > 100) {
        $primary.stick_in_parent({
          offset_top: offset
        });
      }

      $(window).resize(function() {
        if ($(window).width() < 992) {
          $sidebar.trigger('sticky_kit:detach');
          $primary.trigger('sticky_kit:detach');
        }
        else if($sidebar.outerHeight() < $primary.outerHeight()) {
          $sidebar.stick_in_parent({
            offset_top: offset
          });
        }
        else {
          $primary.stick_in_parent({
            offset_top: offset
          });
        }
      });
    },
    
    update: function() {
      var self = this;
      
      $(self.settings.toggle).on('change', function() {
        $(document.body).trigger("sticky_kit:recalc");
      });
    }
  });

  return SidebarSticky;
})();

theme.HeaderMobile = (function() {
  function HeaderMobile(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      headerFixed: '.header__mobile.is-fixed',
      navOpenIcon: '.mobile-nav__open',
      navCloseIcon: '.mobile-nav__close',
      navWrapper: '.mobile-header__nav .mobile__menu',
      megaMenu: '#phantom__menu',
    };

    this._initHeaderFixed();
    this._initMenu();
    this._productsSlider();
    theme.Search.init();
    theme.MiniCart.init();
  }

  HeaderMobile.prototype = _.assignIn({}, HeaderMobile.prototype, {
    _animMenu: function() {
      var tl = new TimelineLite(),
          nav_list = $(".mobile__menu .listitem-0"),
          nav_list_item = $(".mobile__menu .listitem-0 > .listitem > .site-nav__link");

      if (theme.settings.rtl) {
        tl.fromTo(nav_list, .1, {autoAlpha: 0}, {autoAlpha: 1}, 0);
        tl.staggerFromTo(nav_list_item, 2, {opacity:0, y:150, x:-30, rotation:-10}, {opacity:1, y:0, x:0, rotation:0, ease: Power4.easeInOut}, .08, -0.8);
      }
      else {
        tl.fromTo(nav_list, .1, {autoAlpha: 0}, {autoAlpha: 1}, 0);
        tl.staggerFromTo(nav_list_item, 2, {opacity:0, y:150, x:30, rotation:10}, {opacity:1, y:0, x:0, rotation:0, ease: Power4.easeInOut}, .08, -0.8);
      }
    },
    
    _initHeaderFixed: function() {
      if ($(this.selectors.headerFixed).length) {
        var header = $(this.selectors.headerFixed);
        var headerMain = header.parent();
        
        function fixedCalc() {
          if (header.is(':visible')) {
            var height = header.outerHeight();

            header.addClass('finished');
            headerMain.css('height', height);
          }
        }
        fixedCalc();
        
        $(window).resize(function() {
          fixedCalc();
        });

        var padding = 10;
        var height = $(headerMain).offset().top + padding;

        function initSticky() {
          var scrollTop = $(window).scrollTop();
          var height = $(headerMain).offset().top + padding;

          if (height <= scrollTop) {
            $(header).removeClass('unstick').addClass('stick');
          }
          else {
            $(header).removeClass('stick').addClass('unstick');
          }
        }

        initSticky();
        
        $(window).scroll(function() {
          initSticky();
        });
      }
    },

    _initMenu: function() {
      if (typeof $.fn.roarmenu == 'undefined') {
        return false;
      }
      
      var self = this;
      var selectors = self.selectors;

      if ($(selectors.navWrapper).hasClass('has-megamenu') && $(selectors.megaMenu).length) {
        var megamenu = $($(selectors.megaMenu).val());
        megamenu.find('.product__form').remove();
        megamenu.find('.site-nav__dropdown:not(.drilldown)').removeAttr('class').removeAttr('style');
        megamenu.find('.drilldown').removeAttr('class').addClass('drilldown');
        megamenu.find('.text-left').removeClass('text-left');
        megamenu.find('.text-center').removeClass('text-center');
        megamenu.find('.text-right').removeClass('text-right');
        
        $(selectors.navWrapper).find('.listitem-1').remove();
        $(selectors.navWrapper + ' .listitem-0').prepend(megamenu.find('.site-nav__items > .site-nav__item').removeAttr('class'));
      }

      if ($(selectors.navWrapper).length) {
        $(selectors.navWrapper).roarmenu({
          navbar: {
            add: !0,
            close: "mobile-nav__close",
            back: theme.strings.back,
            title: theme.strings.menu,
            titleLink: "anchor"
          }
        });
      }

      $(document).off('click', selectors.navOpenIcon);
      $(document).on('click', selectors.navOpenIcon, function(evt) {
        evt.preventDefault();
        $('body').addClass('menu-opened');
        self._animMenu();
      });

      $(document).off('click', selectors.navCloseIcon);
      $(document).on('click', selectors.navCloseIcon, function(evt) {
        evt.preventDefault();
        $('body').removeClass('menu-opened');
      });
    },
    
    _productsSlider: function() {
      var sections = new theme.Sections();
      sections.register('products-slider-sub', theme.ProductsSlider);
    },
    
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    }
  });

  return HeaderMobile;
})();

theme.HeaderSection = (function() {
  function Header(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    
    this._initElements();
    this._initSticky();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    _initElements: function() {
      theme.Search.init();
      theme.CurrencyPicker.init();
      theme.LanguagePicker.init();
      theme.MiniCart.init();

      var sections = new theme.Sections();
      sections.register('mega-menu', theme.MegaMenu);
      //sections.register('vertical-menu', theme.VerticalMenu);
    },
    
    _initSticky: function() {
      var headerSticky = '#shopify-section-header-sticky';
      var headerMain = '#shopify-section-header';
      var headerPlus = '#shopify-section-header-topbar';

      if (!$(headerSticky).length) {
        return;
      }

      var padding = 200;
      var currentTop = 0;
      var height = $(headerMain).offset().top + $(headerMain).outerHeight() + $(headerPlus).outerHeight() + padding;
      var maxHeight = height + 400;

      $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();

        if ($(headerSticky).is(':visible')) {

          if (height > scrollTop) {
            if ($(headerSticky).hasClass('stick')) {
              $(headerSticky).removeClass('stick').removeClass('sticky-hide').addClass('unstick');
              currentTop = scrollTop;
            }
          }
          else {
            if (!$(headerSticky).hasClass('stick')) {
              $(headerSticky).removeClass('unstick').addClass('stick');
              currentTop = scrollTop;
            }
          }
          
          /*
          if (scrollTop > maxHeight) {
            if (scrollTop > currentTop + padding) {
              $(headerSticky).addClass('sticky-hide');
              currentTop = scrollTop;
            }
            else if (scrollTop < currentTop - padding) {
              $(headerSticky).removeClass('sticky-hide');
              currentTop = scrollTop;
            }
          }
          */
        }
      });

      function initSticky() {
        var scrollTop = $(window).scrollTop();
        var height = $(headerMain).offset().top + $(headerMain).outerHeight() + $(headerPlus).outerHeight() + padding;

        if (height <= scrollTop) {
          $(headerSticky).addClass('stick');
        }
      }
      
      initSticky();
    }
  });

  return Header;
})();

theme.MegaMenu = (function() {
  function MegaMenu() {
    this._initMenu();
    this._navigationInit();
    this._productsSlider();
  }

  MegaMenu.prototype = _.assignIn({}, MegaMenu.prototype, {
    _initMenu: function() {
      var el_source = '#phantom__menu';
      var el_target = '.header__menu';
      var el_target_left = '.header__menu-left';
      var el_target_right = '.header__menu-right';

      if ($(el_source).length && $(el_target).length) {
        $(el_target).each(function() {
          var clone = $(el_source).val();
          $(this).empty().append(clone);
        });
      }

      if ($(el_source).length && $(el_target_left).length) {
        var clone = $($(el_source).val());
        clone.find('.site-nav__items > .site-nav__item').each(function() {
          if ($(this).hasClass('pull-right')) {
            $(this).remove();
          }
        });

        $(el_target_left).each(function() {
          var clone2 = clone.clone();
          $(this).empty().append(clone2);
        });
      }

      if ($(el_source).length && $(el_target_right).length) {
        var clone = $($(el_source).val());
        clone.find('.site-nav__items > .site-nav__item').each(function() {
          if (!$(this).hasClass('pull-right')) {
            $(this).remove();
          }
        });

        $(el_target_right).each(function() {
          var clone2 = clone.clone();
          $(this).empty().append(clone2);
        });
      }
    },
    
    _navigationInit: function() {
      var overlay_triggers_list = [
        ".site-navigation .site-nav__items > .site-nav--has-dropdown",
        ".my-account-has-drop",
        ".currency__picker .has-drop",
        ".language__picker .has-drop"
      ];

      var overlay_triggers = overlay_triggers_list.join(", ");

      $(overlay_triggers).mouseenter(function(e) {
        $(this).closest('.site-header-main, .header-sticky__placeholder').attr('data-sticky', 'visible');
        $('.site-overlay').addClass('visible');
      }).mouseleave(function(e) {
        $('.site-overlay').removeClass('visible');
        $(this).closest('.site-header-main, .header-sticky__placeholder').removeAttr('data-sticky', 'visible');
      });
    },

    _productsSlider: function() {
      var sections = new theme.Sections();
      sections.register('products-slider-sub', theme.ProductsSlider);
    },
    
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    }
  });

  return MegaMenu;
})();

theme.VerticalMenu = (function() {
  function VerticalMenu() {
    this.init();
  }

  VerticalMenu.prototype = _.assignIn({}, VerticalMenu.prototype, {
    init: function() {
      var el_source = '.phantom__menu-vertical .site-nav__vertical';
      var el_target = '.header__menu-vertical';

      if ($(el_source).length && $(el_target).length) {
        $(el_target).each(function() {
          var clone = $(el_source).clone();
          $(this).empty().append(clone);
        });
      }
    }
  });

  return VerticalMenu;
})();

theme.Maps = (function() {
  var config = {
    zoom: 19
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
      .then(
        function(results) {
          
          var e = [];
          e[0] = {}, e[1] = {}, e[2] = {};

          var a = [];
          a[0] = {}, a[1] = {}, a[2] = {}, a[3] = {}, a[4] = {}, a[5] = {}, a[6] = {}, a[7] = {}, a[8] = {}, a[9] = {}, a[10] = {}, a[11] = {}, a[12] = {};
          
          var styles = [{
            featureType: "poi",
            elementType: "labels",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "road.local",
            elementType: "labels.icon",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{
              visibility: "off"
            }]
          }, {
            featureType: "transit",
            elementType: "geometry.fill",
            stylers: [{
              hue: "#dadeef"
            }, {
              visibility: "on"
            }, {
              lightness: 1
            }, {
              saturation: 7
            }]
          }, {
            elementType: "labels",
            stylers: [{
              saturation: -100
            }]
          }, {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [{
              hue: "#dadeef"
            }, {
              visibility: "on"
            }, {
              lightness: 20
            }, {
              saturation: 7
            }]
          }, {
            featureType: "landscape",
            stylers: [{
              hue: "#dadeef"
            }, {
              visibility: "on"
            }, {
              lightness: 20
            }, {
              saturation: 20
            }]
          }, {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{
              hue: "#dadeef"
            }, {
              visibility: "on"
            }, {
              lightness: 1
            }, {
              saturation: 7
            }]
          }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
              hue: "#dadeef"
            }, {
              visibility: "on"
            }, {
              lightness: 1
            }, {
              saturation: 7
            }]
          }, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], e[0], e[1], e[2]];
          var mapType = new google.maps.StyledMapType(styles, {
            name: "Styled Map"
          });
          
          var mapOptions = {
            center: results[0].geometry.location,
            zoom: config.zoom,
            mapTypeControlOptions: {
              mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"]
            },
            scrollwheel: !1,
            panControl: !1,
            zoomControl: 1,
            disableDoubleClickZoom: 1,
            zoomControlOptions: {
              style: google.maps.ZoomControlStyle.LARGE,
              position: google.maps.ControlPosition.LEFT_CENTER
            },
            mapTypeControl: !1,
            scaleControl: !1,
            streetViewControl: !1,
            fullscreenControlOptions: {
              position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          map.mapTypes.set("map_style", mapType);
          map.setMapTypeId("map_style");
          
          var center = (this.center = map.getCenter());

          //eslint-disable-next-line no-unused-vars
          var myoverlay = new google.maps.OverlayView();
          myoverlay.draw = function () {
            var t = this,
                e = this.div_,
                a;
            e || ((e = this.div_ = $('<div><div class="animated-dot"><div class="pin"></div><div class="pulse"></div></div></div>')[0]).style.position = "absolute", e.style.paddingLeft = "0px", e.style.cursor = "pointer", this.getPanes().overlayImage.appendChild(e));
            
          };
          myoverlay.setMap(map);

          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      mediaQueryLargeUp: 'screen and (min-width: 992px)',
      mediaQueryMedium: 'screen and (max-width: 991px)',
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.ProductSection-' + sectionId,
      sectionId: sectionId,
      sectionType: $container.data('section-type'),
      zoomEnabled: false,
      sliderThumbsActive: false,
      sliderImagesActive: false,
      swatchColor: $container.data('product_swatch_color'),
      swatchColorAdvanced: $container.data('product_swatch_color_advanced'),
      swatchSize: $container.data('product_swatch_size'),
    };

    this.selectors = {
      container: $container,
      inComing: '.InComing-' + sectionId,
      addToCart: '.AddToCart-' + sectionId,
      addToCartText: '.AddToCartText-' + sectionId,
      comparePrice: '.ComparePrice-' + sectionId,
      originalPrice: '.ProductPrice-' + sectionId,
      SKU: '.product-single__sku',
      originalSelectorId: '.ProductSelect-' + sectionId,
      productImage: '.ProductImage-' + sectionId,
      productImages: '.product-single__photos-' + sectionId,
      productImageWraps: '.product-single__photo-' + sectionId,
      productVideo: '.product-single__video-' + sectionId,
      productVideoWrap: '.product-single__video-wrapper',
      productPrices: '.product-single__price-' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productNav: '.product-single__nav-' + sectionId,
      sizeChart: '.sizechart_btn',
      productContent: '.product-single__content',
      productQuantity: '.product-form__item--quantity',
      productTabs: '.product-single__tabs',
      productReviews: '.product-single__review',
      productGalleryTrigger: '.product-single__photo.photoswipe-enabled',
      productVideoTrigger: '.product-single__show-video',
      recentlyViewed: '.recently-viewed-' + sectionId,
      cartAgree: '#product-cart__agree-' + sectionId,
      cartCheckout: '#product-buy__1click-' + sectionId,
      stockCountdown: '#product-single__stock-' + sectionId,
      visitorCounter: '#product-single__visitor-' + sectionId,
      totalSold: '#product-single__sold-' + sectionId,

      singleOptionSelector: '.single-option-selector-' + sectionId,
      singleOptionSelectorId: '#SingleOptionSelector-' + sectionId,
      singleOptionSwatchesWrapper: '.wrapper-swatches-' + sectionId,
      singleOptionSwatchesRadio: '.swatch-radio-' + sectionId ,
      
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbImagesWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productMediaTypeVideo: ':not(.slick-cloned)[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      
      
    };
    
    
    this.classes = {
      hidden: 'classes-hide',
      visibilityHidden: 'visibility-hidden',
      activeClass: 'active-thumb',
      jsZoomEnabled: 'js-zoom-enabled',
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('.ProductJson-' + sectionId, $container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($('.ProductJson-' + sectionId, $container).html());
    this.productSwatchSingleObject = JSON.parse($('.ProductSwatchJson-' + sectionId, $container).html());
    this.productMoreSingleObject = JSON.parse($('.ProductMoreJson-' + sectionId, $container).html());

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass('zoom-enabled');
    this._updateProductObject();
    this._initBreakpoints();
    this._initVariants();
    this._initSwatches();
    
    this._initMediaSwitch();
   //  this._initImageSwitch(); 
    
    this._initReviews();
    this._initQuantity();
    this._productInView();
    
    if (this.settings.sectionType == 'product-template') {
      this._initGalleryZoom();
      this._initVideoZoom();
      this._initTabs();
      this._stickyDetails();
      this._recordRecentlyViewed();
      this._sizeChart();
      this._checkoutCart();
      this._initStockCountdown();
      this._visitorCounter();
      this._totalSold();
      this._productNav();
      this._productsSlider();
    }
    
    /* custom events */
    this._initProductVideo();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
    
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    
    
    
    _initMediaSwitch: function() {
      
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      
      $.fn.visible=function(a){var b=$(this),c=$(window),d=c.scrollTop(),e=d+c.height(),f=b.offset().top,g=f+b.height(),h=a===!0?g:f,i=a===!0?f:g;return i<=e&&h>=d};

      var self = this;

      $(this.selectors.productThumbImages)
      .on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var mediaId = $el.data('thumbnail-id');
        self._switchMedia(mediaId);
        self._setActiveThumbnail(mediaId);

        
        })
        .on('keyup', self._handleMediaFocus.bind(self));

      $(self.selectors.productThumbs).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var slide = $(self.selectors.productThumbs).find('.slick-slide').eq([nextSlide]);
        if (slide.find('.product-single__thumbnail').length) {
          var thumbnail = slide.find('.product-single__thumbnail');
          var imageId = thumbnail.data('thumbnail_id');

          $(self.selectors.productVideo).data('thumbnail_prev', imageId);
          $(self.selectors.productVideoWrap).hide();
          $(self.selectors.productImages).show();
          self._pauseVideo();
        }
      });
      
      $(self.selectors.productImages).on('afterChange', function(event, slick, currentSlide) {
        var slide = $(self.selectors.productImages).find('.slick-slide').eq([currentSlide]);
        var mediaId = slide.data("media-id");
        self._switchMedia(mediaId);
      });
      
      
      $(self.selectors.productVideo).on('click', function() {
        var that = $(this);
        var imageId = that.data('thumbnail_prev');
        
        if (that.hasClass('played')) {
          var $prevImage = $(self.selectors.productThumbImages + "[data-thumbnail_id='" + imageId + "']")[0];
          $prevImage.click();
        }
        else {
          $(self.selectors.productThumbs).find('.slick-slide').removeClass('slick-current');
          $(self.selectors.productImages).hide();
          $(self.selectors.productVideoWrap).show();
          
          self._playVideo(imageId);
        }
      });

      $(window).scroll(function(event) {
        $(self.selectors.productImageWraps).each(function(i, el) {
          var that = $(el);
          if (that.visible(true)) {
            that.addClass('come-in'); 
          } 
        });
      });
      
    },
    _setActiveThumbnail: function(mediaId) {
      
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === 'undefined') {
        mediaId = $(
          this.selectors.productMediaWrapper + ':not(.'+this.classes.hidden+')',
          this.$container
        ).data('media-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        mediaId +
        "']"
      );

      $(this.selectors.productThumbImages)
      .removeClass(this.classes.activeClass)
      .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbImagesWrapper).slick('slickGoTo', slideIndex, true);
    },
    _initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
        var $el = $(this);
        theme.ProductVideo.init($el, sectionId);
      });
    },
    _initModelViewerLibraries: function() {
      var $modelViewerElements = $(
        this.selectors.productMediaTypeModel,
        this.$container
      );
      if ($modelViewerElements.length < 1) return;
      theme.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },
    _initShopifyXrLaunch: function() {
      var self = this;
      $(document).on('shopify_xr_launch', function() {
        var $currentMedia = $(
          self.selectors.productMediaWrapper +
            ':not(.' +
            self.classes.hidden +
            ')',
          self.$container
        );
        $currentMedia.trigger('xrLaunch');
      });
    },
    _updateMedia: function(evt) {
      var variant = evt.variant;
      if (!variant || !variant.featured_media) return;
      var mediaId = variant.featured_media.id;
      var sectionMediaId = this.settings.sectionId + '-' + mediaId;

      this._switchMedia(sectionMediaId);
      this._setActiveThumbnail(sectionMediaId);
    },
    _switchMedia: function(mediaId) {
      var $currentMedia = $(
        this.selectors.productMediaWrapper +
        ':not(.' +
        this.classes.hidden +
        ')',
        this.$container
      );

      var $newMedia = $(
        this.selectors.productMediaWrapper +
        "[data-media-id='" +
        mediaId +
        "']",
        this.$container
      );

      var $otherMedia = $(
        this.selectors.productMediaWrapper +
        ":not([data-media-id='" +
        mediaId +
        "'])",
        this.$container
      );
      
      /* Navigate Slick slider to the correct slide */
      var $slider = $(this.selectors.productImages);
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        var slideIndex = -1;
        $slider.find('.slick-slide:not(.slick-cloned)').each(function(i) {
          if ($(this).find("[data-media-id='" + mediaId + "']").length > 0 ||
              $(this).attr('data-media-id') === mediaId) {
            slideIndex = i;
            return false;
          }
        });
        if (slideIndex === -1) {
          // Try matching by the wrapper itself being the slide
          $slider.find('.slick-slide:not(.slick-cloned) [data-media-id]').each(function(i) {
            if ($(this).data('media-id') == mediaId) {
              slideIndex = i;
              return false;
            }
          });
        }
        if (slideIndex >= 0) {
          $slider.slick('slickGoTo', slideIndex);
        }
      }

      $currentMedia.trigger('mediaHidden');
      $newMedia.trigger('mediaVisible');
      $newMedia.removeClass(this.classes.hidden).trigger('mediaVisible');

      $otherMedia.addClass(this.classes.hidden);
      
      
    },
    _handleMediaFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      var mediaId = $(evt.currentTarget).data('thumbnail-id');

      $(
        this.selectors.productMediaWrapper +
        "[data-media-id='" +
        mediaId +
        "']",
        this.$container
      ).focus();
    },
    

    _initImageSlider: function(mobile) {
      if (typeof mobile == "undefined") {
        mobile = true;
      }
      var self = this;
      var adaptiveHeight =!1;
      if ($(self.selectors.productImages).data('adaptive_height') == "1") {
        adaptiveHeight = !0;
      }
      var options = {
        infinite: !1,
        adaptiveHeight: adaptiveHeight,
        rtl: theme.settings.rtl,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: true,
        arrows: true,
        prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-prev2"></use></svg></button>',
        nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-next2"></use></svg></button>',
        asNavFor: self.selectors.productThumbs,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              adaptiveHeight : !0
            }
          }
        ]
      };

      if (mobile == false) {
        if ($(self.selectors.productImages).data('center_mode') == true) {
          options.centerMode = true;
          options.centerPadding = '25%';
          options.fade = false;
          options.arrows = true;
        }
      }
      else {
        options.slidesToShow = 1;
        options.fade = false;
        options.dots = true;
        options.arrows = false;
      }
      if ($(self.selectors.productImages).closest('.product-single__photos').find('.carousel-status').length) {
        var carouselStatus = $(self.selectors.productImages).closest('.product-single__photos').find('.carousel-status');
        $(self.selectors.productImages).on('beforeChange', function(event, obj, currentSlide, nextSlide) {
          carouselStatus.html('<span>' + (nextSlide + 1) + '</span>' + '/' + '<span>' + obj.$slides.length + '</span>');
        });
      }
      if (theme.settings.animation) {
        $(self.selectors.productImages).on('init', function(event, obj) {
          var tl = new TimelineLite(),
              gallery = obj.$slider,
              single_gallery = gallery.parent();

          tl.fromTo(gallery, 1, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 0);
          tl.fromTo(single_gallery, 2, {scale: 1.1, opacity:0}, {ease: Power4.easeInOut,scale: 1, opacity:1}, .3);
        });
      }
      self.settings.sliderImagesActive = true;
      $(self.selectors.productImages).slick(options);
    },

    _initThumbnailSlider: function(mobile) {
      
      if (typeof mobile == "undefined") {
        mobile = true;
      }
      var self = this;
      var is_vertical = false;
      if (mobile == false && $(self.selectors.productThumbs).data('vertical') == true) {
        is_vertical = true;
      }

      var options = {
        rtl: theme.settings.rtl,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: is_vertical,
        verticalSwiping: is_vertical,
        asNavFor: self.selectors.productImages,
        focusOnSelect: true,
        arrows: false,
      };
      if (theme.settings.animation) {
        $(self.selectors.productThumbs).on('init', function(event, obj) {
          var tl = new TimelineLite(),
              single_gallery_th = obj.$slider;

          tl.fromTo(single_gallery_th.find('.slick-list'), 1.4, {y:20, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1, onStart:thShadow }, 1);
          function thShadow () {
            setTimeout(function() {
              single_gallery_th.addClass('shadow');
            }, 600);
          }; 
        });
      }
      self.settings.sliderThumbsActive = true;
      $(self.selectors.productThumbs).slick(options);
    },

    _destroyImageSlider: function() {
      $(this.selectors.productImages).slick('unslick');
      this.settings.sliderImagesActive = false;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderThumbsActive = false;
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      $.fn.visible=function(a){var b=$(this),c=$(window),d=c.scrollTop(),e=d+c.height(),f=b.offset().top,g=f+b.height(),h=a===!0?g:f,i=a===!0?f:g;return i<=e&&h>=d};

      var self = this;

      $(document).off('click', self.selectors.productThumbImages);
      $(document).on('click', self.selectors.productThumbImages, function(evt) {
        evt.preventDefault();
      });

      $(self.selectors.productThumbs).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var slide = $(self.selectors.productThumbs).find('.slick-slide').eq([nextSlide]);
        if (slide.find('.product-single__thumbnail').length) {
          var thumbnail = slide.find('.product-single__thumbnail');
          var imageId = thumbnail.data('thumbnail_id');
          
          $(self.selectors.productVideo).data('thumbnail_prev', imageId);
          $(self.selectors.productVideoWrap).hide();
          $(self.selectors.productImages).show();
          self._pauseVideo();
        }
      });
      
      $(self.selectors.productVideo).on('click', function() {
        var that = $(this);
        var imageId = that.data('thumbnail_prev');
        
        if (that.hasClass('played')) {
          var $prevImage = $(self.selectors.productThumbImages + "[data-thumbnail_id='" + imageId + "']")[0];
          $prevImage.click();
        }
        else {
          $(self.selectors.productThumbs).find('.slick-slide').removeClass('slick-current');
          $(self.selectors.productImages).hide();
          $(self.selectors.productVideoWrap).show();
          
          self._playVideo(imageId);
        }
      });

      $(window).scroll(function(event) {
        $(self.selectors.productImageWraps).each(function(i, el) {
          var that = $(el);
          if (that.visible(true)) {
            that.addClass('come-in'); 
          } 
        });
      });
    },

    _switchImage: function(image) {
      
      if (this.settings.sectionType == 'product-quickview') {
        var $image = $(this.selectors.productImage, this.selectors.container);
        $image.attr('data-bgset', theme.roarJs.bgSet(image)).removeClass('lazyloaded').addClass('lazyload');
        
        return;
      }
      
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var $newImage = $(this.selectors.productThumbImages + "[data-thumbnail_id='" + image.id + "']")[0];
      $newImage.click();
    },
    
    

    _initBreakpoints: function() {
      var self = this;
      
      enquire.register(self.settings.mediaQueryMedium, {
        match: function() {
          if (self.settings.sliderThumbsActive) {
            self._destroyThumbnailSlider();
          }
          self._initThumbnailSlider();
        }
      });

      enquire.register(self.settings.mediaQueryLargeUp, {
        match: function() {
          if (self.settings.sliderThumbsActive) {
            self._destroyThumbnailSlider();
          }
          self._initThumbnailSlider(false);
        }
      });

      enquire.register(self.settings.mediaQuerySmall, {
        match: function() {
          if (self.settings.sliderImagesActive) {
            self._destroyImageSlider();
          }
          self._initImageSlider();

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }
        }
      });

      enquire.register(self.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.sliderImagesActive) {
            self._destroyImageSlider();
          }
          self._initImageSlider(false);

          // initialize image zooming
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },
    
    _productNav: function() {
      var self = this;
      if ($(self.selectors.productNav).length) {
        var $product_nav = $(self.selectors.productNav);
        var $trigger_top = $product_nav;
        var $trigger_bottom = $('.product-template__end');

        var productNavToggle = function () {
          var nav_Offset_Top = $trigger_top.offset().top / 3;
          var nav_Offset_Bottom = $trigger_bottom.offset().top - 400;
          var windowScroll = $(window).scrollTop();


          if (nav_Offset_Top < windowScroll) {
            $product_nav.addClass('visible');
          } else {
            $product_nav.removeClass('visible');
          }

          if (nav_Offset_Bottom < windowScroll) {
            $product_nav.removeClass('visible');
          }        
        }; 

        productNavToggle();

        $(window).scroll(productNavToggle);
        $(window).resize(productNavToggle);   
      }
    },
    
    _productInView: function() {
      if (typeof ScrollReveal == 'undefined' || theme.settings.animation == false) {
        return false;
      }

      window.sr = ScrollReveal();

      sr.reveal('.product-single__inview:not(.no-anim)', {
        mobile: true,
        beforeReveal: function (domEl) {
          domEl.visuelRevealTL = new TimelineLite();
          
          $(domEl).addClass('anim');
          domEl.visuelRevealTL.fromTo(domEl, 2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1},0).call(function(obj) {
            $(domEl).removeClass('anim').addClass('no-anim');
          });
        } 
      });
    },
    
    _updateProductObject: function() {
      var self = this;
      
      $.each(self.productMoreSingleObject.variants, function(index, variant) {
        $.each(variant, function(name, value) {
          (self.productSingleObject.variants[index])[name] = value;
        });
      });
    },
    
    _totalSold: function() {
      
      if (!$(this.selectors.totalSold).length) {
        return;
      }
      
      var that = $(this.selectors.totalSold);
      var min_qty = that.data('qty_min');
      var max_qty = that.data('qty_max');
      var min_time = that.data('time_min');
      var max_time = that.data('time_max');
      
      min_qty = Math.ceil(min_qty);
      max_qty = Math.floor(max_qty);
      min_time = Math.ceil(min_time);
      max_time = Math.floor(max_time);

      var qty = Math.floor(Math.random() * (max_qty - min_qty + 1)) + min_qty;
      qty = parseInt(qty);
      if (qty <= min_qty) {
        qty = min_qty;
      }
      if (qty > max_qty) {
        qty = max_qty;
      }
      that.html(that.html().replace('/count/', qty));

      var time = Math.floor(Math.random() * (max_time - min_time + 1)) + min_time;
      time = parseInt(time);
      if (time <= min_time) {
        time = min_time;
      }
      if (time > max_time) {
        time = max_time;
      }
      that.html(that.html().replace('/time/', time));
      
      that.addClass('active');
      
      if (that.find('img').first().length) {
        setInterval(function() {
          that.find('img').first().fadeIn(function() {
            $(this).css('visibility', 'visible');
          }).delay(1600).fadeIn(function() {
            $(this).css('visibility', 'hidden');
          }).delay(400);
        }, 2000);
      }
    },
    
    _visitorCounter: function() {
      
      if (!$(this.selectors.visitorCounter).length) {
        return;
      }
      
      var that = $(this.selectors.visitorCounter);
      var min = 1;
      var max = that.data('max');
      var interval = that.data('interval');

      var t = min;
      var r = max;
      t = Math.ceil(t);
      r = Math.floor(r);

      var o = Math.floor(Math.random() * (r - t + 1)) + t,
          n = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
          h = "",
          e = "",
          l = ["10", "20", "15"],
          h = "",
          e = "",
          M = "";
      setInterval(function() {
        if (h = Math.floor(Math.random() * n.length), e = n[h], o = parseInt(o) + parseInt(e), min >= o) {
          M = Math.floor(Math.random() * l.length);
          var a = l[M];
          o += a;
        }
        if (o < 1 || o > max) {
          o = Math.floor(Math.random() * (r - t + 1)) + t;
        }

        that.find('strong').first().text(parseInt(o));
        that.addClass('active');
      }, interval * 1000);
    },
    
    _initStockCountdown: function() {
      
      if (!$(this.selectors.stockCountdown).length) {
        return;
      }
      var self = this;
      var that = $(self.selectors.stockCountdown);

      if (that.hasClass('is-fake')) {
        var total_items = 60;
        var min_items = that.data('min');
        var max_items = that.data('max');
        var remaining_items = randomNumber(min_items, max_items);
        var check_stock = false;
        var timer = null, timerinterval = null;
        var min_remaining_items = 1;
        var decrease_after = 1.7; 
        var decrease_after_first_time = 3; 

        progressBar();
        if (that.hasClass('is-visible')) {
          that.removeClass('hide');
        }

        function randomNumber(min, max) {
          return Math.floor(Math.random() * (max - min + 1) + min);
        }

        function progressBar() {
          that.find('.stock-countdown-message').first().html(theme.strings.onlyLeft.replace('{{ count }}', remaining_items));

          timer = setTimeout(function() {
            remaining_items--;
            if (remaining_items < min_remaining_items) {
              remaining_items = randomNumber(min_items, max_items);
            }

            that.find('.stock-countdown-message strong').text(remaining_items);
            updateMeter();

            if (remaining_items < min_items) {
              clearTimeout(timer);
            }
          }, 1000 * decrease_after_first_time);

          timerinterval = setInterval(function() {
            remaining_items--;
            if (remaining_items < min_remaining_items) {
              remaining_items = randomNumber(min_items, max_items);
            }

            that.find('.stock-countdown-message strong').text(remaining_items);
            updateMeter();

            if (remaining_items < min_items) {
              clearInterval(timerinterval);
            }
          }, 1000 * 60 * decrease_after);
        }

        function updateMeter() {
          var percent = 100 * remaining_items / total_items;
          that.find('.progress-bar span').css('width', percent + '%');
        }
      }
    },
    
    _updateStockCountdown: function(inventory_quantity) {
      var that = $(this.selectors.stockCountdown);
      
      if (that.hasClass('is-fake')) {
        that.removeClass('hide');
      }
      else {
        that.find('.stock-countdown-message').first().html(theme.strings.onlyLeft.replace('{{ count }}', inventory_quantity));
        that.find('.progress-bar span').first().css('width', '100%');
        that.removeClass('hide');
        setTimeout(function() {
          that.find('.progress-bar span').first().css('width', '28%');
        }, 500);
      }
    },

    _checkoutCart: function() {
      var self = this;
      
      if (!$(self.selectors.cartAgree).length) {
        return;
      }

      $(document).on('DOMNodeInserted', self.selectors.cartCheckout, function() {
        var that = $(this);
        setTimeout(function() {
          var shopify_payment_button = that.find('.shopify-payment-button__button');
          if (shopify_payment_button.length) {
            that.hide();

            setTimeout(function() {
              var agree = $(self.selectors.cartAgree);
              if (agree.is(':checked')) {
                shopify_payment_button.removeClass('btn-disabled');
              }
              else {
                shopify_payment_button.addClass('btn-disabled');
              }

              that.fadeIn();
            }, 300);
          }
        }, 0);
      });

      $(document).on('change', self.selectors.cartAgree, function(evt) {
        var agree = $(this);
        var shopify_payment_button = $(self.selectors.cartCheckout).find('.shopify-payment-button__button');

        if (agree.is(':checked')) {
          shopify_payment_button.removeClass('btn-disabled');
        }
        else {
          shopify_payment_button.addClass('btn-disabled');
        }
      });
    },

    _pauseVideo: function() {
      var $video = $(this.selectors.productVideoWrap).find('video')[0];

      if ($video && $video.played) {
        $video.pause();
        $video.load();
      }
      $(this.selectors.productVideo).removeClass('played');
    },

    _playVideo: function(imagePrev) {
      var self = this;
      var $video = $(self.selectors.productVideoWrap).find('video')[0];

      if ($video) {
        $video.play();

        var played = 1;
        $video.addEventListener('ended', function() {
          if (played < 2) {
            $video.play();
            played++;
          }
          else {
            var $prevImage = $(self.selectors.productThumbImages + "[data-thumbnail_id='" + imagePrev + "']")[0];
            $prevImage.click();
          }
        }, false);
      }
      $(self.selectors.productVideo).addClass('played');
    },
    
    _initVideoZoom: function() {
      var self = this;
      var $pswp = $('.pswp')[0];

      $(document).off('click', self.selectors.productVideoTrigger);
      $(document).on('click', self.selectors.productVideoTrigger, function(evt) {
        evt.preventDefault();
        
        var $target = $(this).parent();
        var options = {
          index: 0,
          closeOnScroll: false,
          bgOpacity: .1,
          tapToClose: true,
          tapToToggleControls: false,
        }

        // Initialize PhotoSwipe
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, getProductVideo(), options);
        lightBox.init();
        
        $("body").addClass('blurred');
        $(".pswp__item").fadeTo(1000, 1);

        lightBox.listen('close', function() {
          $('.pswp__item .pswp__video').each(function() {
            $(this).attr('src', $(this).attr('src'));
          });
          $(".pswp__item").fadeOut("slow", 0);
          $("body").removeClass('blurred');
        });
      });
      
      function getProductVideo() {
        var items = [];
        
        items.push({
          html: $(self.selectors.productVideoWrap + ' .product-single__video').html()
        });

        return items;
      };
    },

    _initGalleryZoom: function() {
      var self = this;
      var $pswp = $('.pswp')[0];

      $(document).off('click', self.selectors.productGalleryTrigger);
      $(document).on('click', self.selectors.productGalleryTrigger, function(evt) {
        evt.preventDefault();

        var $target = $(this).parent();
        var $index = $(this).data('index');
        var options = {
          index: $index,
          closeOnScroll: false,
          bgOpacity: .1,
          tapToClose: true,
          tapToToggleControls: false,
        }

        // Initialize PhotoSwipe
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, getProductItems(), options);
        lightBox.init();
        
        // Image loaded
        lightBox.listen('imageLoadComplete', function(index, item) {
          $(".pswp__item").fadeTo(1000, 1);
          $("body").addClass('blurred');
        });

        // Image Close
        lightBox.listen('close', function(index, item) {
          $(".pswp__item").fadeOut("slow", 0);
          $("body").removeClass('blurred');
        });
      });

      function getProductItems() {
        var items = [];

        $(self.selectors.productImages + ' .product-single__photo-container:not(.slick-cloned) .feature-row__image').each(function () {
          var src = $(this).data('large_image'),
              width = $(this).data('large_image_width'),
              height = $(this).data('large_image_height');

          items.push({
            src: src,
            w: width,
            h: height,
            title: false
          });

        });

        return items;
      };
    },

    _initQuantity: function() {
      var self = this;

      $(document).off('click', self.selectors.productQuantity + ' .plus');
      $(document).on('click', self.selectors.productQuantity + ' .plus', function() {
        var quantity = $(this).closest(self.selectors.productQuantity).find('.quantity');

        var qty = parseInt(quantity.val());
        qty = qty + 1;
        quantity.val(qty);

        checkQuantity(this);
      });

      $(document).off('click', self.selectors.productQuantity + ' .minus');
      $(document).on('click', self.selectors.productQuantity + ' .minus', function() {
        var quantity = $(this).closest(self.selectors.productQuantity).find('.quantity');

        var qty = parseInt(quantity.val());
        if (qty > 0) {
          qty = qty - 1;
          quantity.val(qty);

          checkQuantity(this);
        }
      });

      function checkQuantity(el) {
        var quantity = 0;

        $(el).closest(self.selectors.productContent).find(self.selectors.productQuantity + ' .quantity').each(function() {
          quantity += parseInt($(this).val());
        });

        if (quantity > 0) {
          $(self.selectors.addToCart).prop('disabled', false);
        }
        else {
          $(self.selectors.addToCart).prop('disabled', true);
        }
      }
    },

    _stickyDetails: function() {
      var details = $(this.selectors.productContent);
      if (!details.data('sticky') || $(window).width() < 992) {
        return;
      }

      details.each(function() {
        var $column = $(this).parent(),
            offset = 20,
            $inner = $(this),
            $images = $column.closest('.product-single').find('.product-single__photos');

        var diff = $inner.outerHeight() - $images.outerHeight();

        if(diff < -100) {
          $inner.stick_in_parent({
            offset_top: offset
          });
        }
        else if(diff > 100) {
          $images.stick_in_parent({
            offset_top: offset
          });
        }

        $(window).resize(function() {
          if ($(window).width() < 992) {
            $inner.trigger('sticky_kit:detach');
            $images.trigger('sticky_kit:detach');
          }
          else if($inner.outerHeight() < $images.outerHeight()) {
            $inner.stick_in_parent({
              offset_top: offset
            });
          }
          else {
            $images.stick_in_parent({
              offset_top: offset
            });
          }
        });
      });
    },

    _initTabs: function() {
      var productTabs = $(this.selectors.productTabs);
      var tabSelector = '.product-tabs__title';
      var panelSelector = '.product-tabs__panel';

      if (productTabs.hasClass('tabs-layout-tabs') || productTabs.hasClass('tabs-layout-accordion')) {
        $(document).off('click', tabSelector);
        $(document).on('click', tabSelector, function(evt) {
          evt.preventDefault();

          var that = $(this);
          var panel = that.attr('href');
          var tabs = $(tabSelector, productTabs);
          var panels = $(panelSelector, productTabs);

          window.history.pushState('', '', `${window.location.href.split('#')[0]}${panel}`);
          const elementToScrollTo = document.querySelector(panel);
          console.log(panel, 'elementToScrollTo');
          setTimeout(function(){
            if (elementToScrollTo){
              const rect = elementToScrollTo.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              window.scrollTo({ 
                top: rect.top + scrollTop - 150, 
                behavior: 'smooth' 
              });
            }
          }, 300)

          if ($('.product-tabs', productTabs).is(':visible')) {
            tabs.removeClass('active');
            panels.removeClass('active');

            that.addClass('active');
            $(panel).addClass('active');
          }
          else {
            if (that.hasClass('active')) {
              that.removeClass('active');
              $(panel).removeClass('active');
            }
            else {
              tabs.removeClass('active');
              panels.removeClass('active');

              that.addClass('active');
              $(panel).addClass('active');
            }

            panels.each(function() {
              if ($(this).hasClass('active')) {
                $(this).slideDown(250);
              }
              else {
                $(this).slideUp(250);
              }
            });
          }
        });
      }
    },

    _initReviews: function() {
      if (!$(this.selectors.productTabs).length) {
        return false;
      }

      var productTabs = this.selectors.productTabs;

      $(document).off('click', this.selectors.productReviews);
      $(document).on('click', this.selectors.productReviews, function() {
        if ($(productTabs).hasClass('tabs-layout-tabs') || $(productTabs).hasClass('tabs-layout-accordion')) {
          var reviewTab = $(productTabs + ' #tab-reviews').prev();

          if ($('.product-tabs', productTabs).is(':visible')) {
            reviewTab = $(productTabs + ' .reviews_tab .product-tabs__title');
          }

          if (!reviewTab.hasClass('active')) {
            reviewTab.trigger('click');
          }
        }

        var scrollElement = $(productTabs + ' #tab-reviews').parent();
        if ($('.product-tabs', productTabs).is(':visible')) {
          scrollElement = $(productTabs);
        }

        setTimeout(function() {
          $('html, body').animate({
            scrollTop: scrollElement.offset().top
          }, 500, 'swing')
        }, 250);
      });
    },

    _initSwatches: function() {
      var radioSwatches =  $(this.selectors.singleOptionSwatchesRadio);
      if(radioSwatches.length == 0) return;

      var self =  this,
      singleOptionSwatchesWrapper = this.selectors.singleOptionSwatchesWrapper,
      productSingleObject = this.productSingleObject,
      singleOptionSelectorId =  this.selectors.singleOptionSelectorId;
      radioSwatches.unbind( "click" );
      radioSwatches.on('click', function(e){
          e.preventDefault();
          var new_val = $(this).data( 'value' );
          var main_select = $(this).closest(singleOptionSwatchesWrapper).find("select");
          var cur_val = main_select.val();
          if(cur_val != new_val) {
            main_select.val(new_val).trigger('change');
            $(this).closest(singleOptionSwatchesWrapper).find(".swatch-radio").removeClass('selected');
            $(this).closest(singleOptionSwatchesWrapper).find("label").removeClass('label-selected');
            $(this).parent().addClass('label-selected');
            $(this).closest(singleOptionSwatchesWrapper).find('.option-select-value').length &&  $(this).closest(singleOptionSwatchesWrapper).find('.option-select-value').html(new_val);

            var self_this = this,
                swatch = $(this).data( 'swatch' ),
                swatch_poption = $(this).data( 'poption' ),
                swatch_value = $(this).data( 'value' );
                swatchCallBack(productSingleObject, swatch_poption, swatch_value, swatch, self_this);
          }
      });
      function swatchCallBack (t, e, r, o, n) {

        if (1 < t.options.length)
          for (var s = 0; s < t.options.length; s++)
            s != e && 

            $(singleOptionSelectorId + '-' + s + ' option').each(function(index, item){

              var swatch_class = 'unavailable',
              option_value = $(item).attr( 'value' ),
              data_swatch = $(item).attr( 'data-swatch' );

              for (j = 0; j < t.variants.length; j++) {
                var n = t.variants[j];
                if (n.options[e] != r) continue;
                else if (n.options[s] == option_value) {
                  swatch_class = !0 == n.available ? 'available' : 'sold_out';
                  break;
                }
              }

              var wrapperOption = $(item).closest(singleOptionSwatchesWrapper).find('.swatch-element.'+ data_swatch);
              wrapperOption.removeClass('available'); 
              wrapperOption.removeClass('sold_out');
              wrapperOption.removeClass('unavailable');
              wrapperOption.addClass(swatch_class);

            })
        else
          for (var s = 0; s < t.options.length; s++)

          $(singleOptionSelectorId + '-' + s + ' option').each(function(index, item){

            var swatch_class = 'unavailable',
            option_value = $(item).attr( 'value' ),
            data_swatch = $(item).attr( 'data-swatch' );

            for (j = 0; j < t.variants.length; j++) {
              var n = t.variants[j];
              if (n.options[s] == option_value) {
                swatch_class = !0 == n.available ? 'available' : 'sold_out';
                break;
              }
            }

            console.log(data_swatch + " - " + swatch_class); 

            var wrapperOption = $(item).closest(singleOptionSwatchesWrapper).find('.swatch-element.'+ data_swatch);
            wrapperOption.removeClass('available'); 
            wrapperOption.removeClass('sold_out');
            wrapperOption.removeClass('unavailable');
            wrapperOption.addClass(swatch_class);

          })
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateMedia.bind(this)
/*        this._updateImages.bind(this) */
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices).removeClass('visibility-hidden');
        
        if (variant.available) {
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', false);
          
          if (variant.inventory_quantity <= 0 && variant.inventory_management == 'shopify') {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder);
          }
          else {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart);
          }
          
          $(this.selectors.productQuantity).removeClass('btn-disabled');
          $(this.selectors.inComing, this.selectors.container).addClass('hide');
          
          if (variant.inventory_quantity > 0 && variant.inventory_management == 'shopify') {
            this._updateStockCountdown(variant.inventory_quantity);
          }
          else {
            $(this.selectors.stockCountdown).removeClass('hide');
          }
          $(this.selectors.totalSold).removeClass('hide');
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
          $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut);
          $(this.selectors.productQuantity).addClass('btn-disabled');
          
          if (variant.incoming) {
            $(this.selectors.inComing, this.selectors.container).html(theme.strings.inComing.replace('{{ date }}', variant.next_incoming_date)).removeClass('hide');
          }
          else {
            $(this.selectors.inComing, this.selectors.container).addClass('hide');
          }
          $(this.selectors.stockCountdown).addClass('hide');
          $(this.selectors.totalSold).addClass('hide');
        }
      } else {
        $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
        $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable);
        $(this.selectors.productQuantity).addClass('btn-disabled');
        
        $(this.selectors.productPrices).addClass('visibility-hidden');
        $(this.selectors.inComing, this.selectors.container).addClass('hide');
        $(this.selectors.stockCountdown).addClass('hide');
        $(this.selectors.totalSold).addClass('hide');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      this._switchImage(variant.featured_image);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(variant.price));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice, this.selectors.container)
        .html(theme.CurrencyPicker.formatMoney(variant.compare_at_price))
        .removeClass('hide');
      }
      else {
        $(this.selectors.comparePrice, this.selectors.container).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    _recordRecentlyViewed: function() {
      
      var storageName = 'roarStorage_recentlyViewed';
      var items = localStorage.getItem(storageName) || '[]';
      try {
        items = JSON.parse(items);
      }
      catch (error) {
        localStorage.removeItem(storageName);
        items = JSON.parse('[]');
      }

      // What is the product ID on this page.
      var productId = this.productSingleObject.id;
      
      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // Remove null item
      var filtered = items.filter(function (item) {
        return item != null;
      });
      
      // Then, we save the current product into the local storage, by keeping only the 180 most recent
      try {
        localStorage.setItem(storageName, JSON.stringify(filtered.slice(0, 180)));
      }
      catch (error) {
        // Do nothing, this may happen in Safari in incognito mode
      }
    },

    _sizeChart: function() {
      var self = this;
      var body = $('body');
      var sizechartModal = $('.sizechart-modal');

      $(document).off('click', self.selectors.sizeChart);
      $(document).on('click', self.selectors.sizeChart, function(evt) {
        evt.preventDefault();

        sizechartModal.addClass('opened');
        body.addClass('sizechart-opened');
      });
      
      $(document).off('click', '.sizechart_overlay, .sizechart_close');
      $(document).on('click', '.sizechart_overlay, .sizechart_close', function(evt) {
        evt.preventDefault();

        sizechartModal.removeClass('opened');
        body.removeClass('sizechart-opened');
      });

      $(document).keyup(function(evt) {
        if (evt.which == '27') {
          sizechartModal.removeClass('opened');
          body.removeClass('sizechart-opened');
        }
      });
      
      $('body').append(sizechartModal);
    },
    
    _productsSlider: function() {
      var sections = new theme.Sections();
      sections.register('products-slider-sub', theme.ProductsSlider);
    },

    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },

    onLoad: function() {
      this._lineItem();
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      duration: 500,
      url: zoomUrl,
      onZoomIn: function() {
        $(this).addClass('active');
      },
      onZoomOut: function() {
        $(this).removeClass('active');
      }
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();



theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });

    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function setupYouTubeVideos() {
    if (!window.YT.Player) return;

    loadVideos(hosts.youtube);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }

      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });

    productMediaWrapper.on('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();


theme.LineItem = (function() {
  function LineItem(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      enableHistoryState: false,
      namespace: '.ProductSection-' + sectionId,
      sectionId: sectionId,
      swatchColor: true,
      swatchColorAdvanced: true,
      swatchSize: true,
    };

    this.selectors = {
      container: $container,
      productImage: '.ProductImage-' + sectionId,
      productColor: '.ProductColor-' + sectionId,
      addToCart: '.AddToCart-' + sectionId,
      addToCartText: '.AddToCartText-' + sectionId,
      comparePrice: '.ComparePrice-' + sectionId,
      originalPrice: '.ProductPrice-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      originalSelectorId: '.ProductSelect-' + sectionId,
      singleOptionSwatchesWrapper: '.wrapper-swatches-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      singleOptionSelectorId: '#SingleOptionSelector-' + sectionId,
      singleOptionSwatches: 'tawcvs-swatches-' + sectionId,
      singleOptionSwatchesRadio: '.swatch-radio-' + sectionId 
    };

    // Stop parsing if we don't have the product json script tag when loading
    if (!$('.ProductJson-' + sectionId, $container).html()) {
      return;
    }
    if ($container.data('section-state')) {
      return;
    }

    this.productSingleObject = JSON.parse($('.ProductJson-' + sectionId, $container).html());
    this.productSwatchSingleObject = JSON.parse($('.ProductSwatchJson-' + sectionId, $container).html());
    this.productMoreSingleObject = JSON.parse($('.ProductMoreJson-' + sectionId, $container).html());

    this._updateProductObject();
    this._initVariants();
    this._initSwatches();
    
    $container.data('section-state', true);
  }

  LineItem.prototype = _.assignIn({}, LineItem.prototype, {
    
    _updateProductObject: function() {
      var self = this;
      
      $.each(self.productMoreSingleObject.variants, function(index, variant) {
        $.each(variant, function(name, value) {
          (self.productSingleObject.variants[index])[name] = value;
        });
      });
    },

    _initSwatches: function() {
      var radioSwatches =  $(this.selectors.singleOptionSwatchesRadio);
      if(radioSwatches.length == 0) return;
      var self =  this,
      singleOptionSwatchesWrapper = this.selectors.singleOptionSwatchesWrapper,
      productSingleObject = this.productSingleObject,
      singleOptionSelectorId =  this.selectors.singleOptionSelectorId;
      radioSwatches.unbind( "click" );
      radioSwatches.on('click', function(e){
          e.preventDefault();
          var new_val = $(this).data( 'value' );
          var main_select = $(this).closest(singleOptionSwatchesWrapper).find("select");
          var cur_val = main_select.val();
          if(cur_val != new_val) {
            main_select.val(new_val).trigger('change');
            $(this).closest(singleOptionSwatchesWrapper).find(".swatch-radio").removeClass('selected');
            $(this).closest(singleOptionSwatchesWrapper).find("label").removeClass('label-selected');
            $(this).parent().addClass('label-selected');
            $(this).closest(singleOptionSwatchesWrapper).find('.option-select-value').length &&  $(this).closest(singleOptionSwatchesWrapper).find('.option-select-value').html(new_val);

            var self_this = this,
                swatch = $(this).data( 'swatch' ),
                swatch_poption = $(this).data( 'poption' ),
                swatch_value = $(this).data( 'value' );
                swatchCallBack(productSingleObject, swatch_poption, swatch_value, swatch, self_this);
          }
      });


      function swatchCallBack (t, e, r, o, n) {

        if (1 < t.options.length)
          for (var s = 0; s < t.options.length; s++)
            s != e && 

            $(singleOptionSelectorId + '-' + s + ' option').each(function(index, item){

              var swatch_class = 'unavailable',
              option_value = $(item).attr( 'value' ),
              data_swatch = $(item).attr( 'data-swatch' );

              for (j = 0; j < t.variants.length; j++) {
                var n = t.variants[j];
                if (n.options[e] != r) continue;
                else if (n.options[s] == option_value) {
                  swatch_class = !0 == n.available ? 'available' : 'sold_out';
                  break;
                }
              }

              var wrapperOption = $(item).closest(singleOptionSwatchesWrapper).find('.swatch-element.'+ data_swatch);
              wrapperOption.removeClass('available'); 
              wrapperOption.removeClass('sold_out');
              wrapperOption.removeClass('unavailable');
              wrapperOption.addClass(swatch_class);

            })
        else
        for (var s = 0; s < t.options.length; s++)
          $(singleOptionSelectorId + '-' + s + ' option').each(function(index, item){

            var swatch_class = 'unavailable',
            option_value = $(item).attr( 'value' ),
            data_swatch = $(item).attr( 'data-swatch' );

            for (j = 0; j < t.variants.length; j++) {
              var n = t.variants[j];
            if (n.options[s] == option_value) {
                swatch_class = !0 == n.available ? 'available' : 'sold_out';
                break;
              }
            }

            var wrapperOption = $(item).closest(singleOptionSwatchesWrapper).find('.swatch-element.'+ data_swatch);
            wrapperOption.removeClass('available'); 
            wrapperOption.removeClass('sold_out');
            wrapperOption.removeClass('unavailable');
            wrapperOption.addClass(swatch_class);

          })
      }

    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices).removeClass('visibility-hidden');

        if (variant.available) {
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', false);
          if (variant.inventory_quantity <= 0 && variant.inventory_management == 'shopify') {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder);
          }
          else {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart);
          }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
          $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
        $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable);
        $(this.selectors.productPrices).addClass('visibility-hidden');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      this._switchImage(variant.featured_image);
      this._switchColor(variant);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(variant.price));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice, this.selectors.container)
        .html(theme.CurrencyPicker.formatMoney(variant.compare_at_price))
        .removeClass('hide');
      }
      else {
        $(this.selectors.comparePrice, this.selectors.container).addClass('hide');
      }
    },

    _switchImage: function(image) {
      var $image = $(this.selectors.productImage);

      $image.attr('data-bgset', theme.roarJs.bgSet(image)).removeClass('lazyloaded').addClass('lazyload');
    },
    
    _switchColor: function(variant) {
      var $colors = $(this.selectors.productColor + ' .swatch-item');
      if ($colors.length) {
        $colors.removeClass('active');
        $colors.each(function() {
          if ($(this).data('variant_id') == variant.id) {
            $(this).addClass('active');
          }
        });
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return LineItem;
})();

theme.Instagram = (function() {
  function Instagram(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      template: '<div class="item"><a href="{{href}}" target="_blank"><span class="meta d-flex align-items-center justify-content-center"><span class="likes">{{likes}}</span><span class="comments">{{comments}}</span></span><img class="lazyload" src="{{src}}" data-srcset="{{srcset}}" /></a></div>',
      accessToken: $container.data('access_token'),
      count: $container.data('count'),
      selector: '#instagram-' + sectionId
    };

    if (this.settings.accessToken == '' || this.settings.count == 0) {
      return;
    }

    this.init();
  }

  Instagram.prototype = _.assignIn({}, Instagram.prototype, {
    init: function(evt) {
      var that = this;
      var url = that._buildUrl();
      $.get(url, function(response) {
        if (typeof response == 'object' && response.meta.code == 200 && response.data.length > 0) {
          var images = response.data;
          var htmlString = '';

          for (i = 0, len = images.length; i < len; i++) {
            var imageString = '';
            var image = images[i];
            var imageUrl = image.images['thumbnail'].url;
            var imagesUrl = image.images['thumbnail'].url + " 150w, " + image.images['low_resolution'].url + " 320w, " + image.images['standard_resolution'].url + " 480w";

            imageString = that._makeTemplate(that.settings.template, {
              href: image.link,
              src: imageUrl,
              srcset: imagesUrl,
              likes: image.likes.count,
              comments: image.comments.count
            });
            htmlString += imageString;
          }

          $(that.settings.selector).append(htmlString);
        }
      });
    },

    _buildUrl: function() {
      var base, endpoint, final;
      base = "https://api.instagram.com/v1";
      endpoint = "users/self/media/recent";
      final = base + "/" + endpoint;
      final += "?access_token=" + this.settings.accessToken;
      final += "&count=" + this.settings.count;
      return final;
    },

    _makeTemplate: function(template, data) {
      var output, pattern, ref, varName, varValue;
      pattern = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/;
      output = template;
      while (pattern.test(output)) {
        varName = output.match(pattern)[1];
        varValue = (ref = this._getObjectProperty(data, varName)) != null ? ref : '';
        output = output.replace(pattern, function() {
          return "" + varValue;
        });
      }
      return output;
    },

    _getObjectProperty: function(object, property) {
      var piece, pieces;
      property = property.replace(/\[(\w+)\]/g, '.$1');
      pieces = property.split('.');
      while (pieces.length) {
        piece = pieces.shift();
        if ((object != null) && piece in object) {
          object = object[piece];
        } else {
          return null;
        }
      }
      return object;
    }
  });

  return Instagram;
})();

theme.CountdownTimer = (function() {
  function CountdownTimer(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      selector: '.countdown-' + sectionId + ':not(.is-countdown)'
    };

    this.regional();
    this.init();
  }

  CountdownTimer.prototype = _.assignIn({}, CountdownTimer.prototype, {
    regional: function() {
      if (typeof $.fn.countdown == 'undefined') {
        return false;
      }
      
      $.countdown.regionalOptions.roar = {
        labels: ['Years', 'Months', 'Weeks', theme.strings.days, theme.strings.hours, theme.strings.minutes, theme.strings.seconds],
        labels1: ['Year', 'Month', 'Week', theme.strings.day, theme.strings.hour, theme.strings.minute, theme.strings.second],
        compactLabels: ['y', 'm', 'w', 'd'],
        whichLabels: null,
        digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        timeSeparator: ':',
        isRTL: theme.settings.rtl
      };
      $.countdown.setDefaults($.countdown.regionalOptions.roar);
    },
    init: function(evt) {
      if (typeof $.fn.countdown == 'undefined') {
        return false;
      }
      
      var $countdown = $(this.settings.selector);

      $countdown.each(function() {
        var that = $(this);

        if (that.data('end_date') != '') {
          var date_string = that.data('end_date').split('-');
          console.log(date_string)
          var end_date = new Date(`${that.data('end_date')}`);
          var current_date = new Date();
          console.log(end_date);
          that.countdown({
            until: end_date,
            alwaysExpire: true,
            onExpiry: function() {
              that.hide();
            }
          });
        }
      });
    }
  });

  return CountdownTimer;
})();

theme.NewsletterPopup = (function() {
  function NewsletterPopup(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      selector: '#newsletter-popup-' + sectionId
    };

    this.init();
  }

  NewsletterPopup.prototype = _.assignIn({}, NewsletterPopup.prototype, {
    init: function(evt) {
      try {
        var $newsletter = $(this.settings.selector);
        var period = $newsletter.data('period');
        var delay = $newsletter.data('delay');
        var version = $newsletter.data('version');

        if (period > 0 && document.cookie.match(/^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/)) {
          return;
        }

        $(window).on('load', function() {
          setTimeout(function() {
            if (version == 'popup2') {
              $(document.body).addClass('newsletter2-opened');
            }
            else {
              $(document.body).addClass('newsletter-opened');
            }
          }, delay * 1000);
        });

        $(document.body).on('roarNewsletter_closed', function(event, modal) {
          var date = new Date(),
              value = date.getTime();
          date.setTime(date.getTime() + (period * 24 * 60 * 60 * 1000));
          document.cookie = 'roarStorage_newsletter=' + value + ';expires=' + date.toGMTString() + ';path=/';
        });

        function closeModal() {
          $(document.body).removeClass('newsletter-opened').removeClass('newsletter2-opened');
          $(document.body).trigger('roarNewsletter_closed', [$newsletter]);
        }
        $(document.body).on('click', '.newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop', function(e) {
          e.preventDefault();
          closeModal();
        });
        $(document).on('keyup', function(e) {
          if (e.keyCode === 27) {
            closeModal();
          }
        });
      } catch(e) {
        return;
      }
    }
  });

  return NewsletterPopup;
})();

theme.LookbookSection = (function() {
  function LookbookSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    
    this.settings = {
      init: false
    }

    this.selectors = {
      lookbookId: '#lookbook__id-' + sectionId + ' .roarlookbook',
      lookbookContent: '#lookbook__content-' + sectionId,
    };

    this.init();
  }

  LookbookSection.prototype = _.assignIn({}, LookbookSection.prototype, {
    init: function(evt) {
      var self = this;
      
      $(document).on('DOMNodeInserted', self.selectors.lookbookId, function() {
        if (self.settings.init == false) {
          self.settings.init = true;
          
          var that = $(this);
          setTimeout(function() {
            that.closest('.slideshow__slide').addClass('slide-active');
            that.find('.media__blank-preview').append($(self.selectors.lookbookContent));
          }, 0);
        }
      });
    },
    
    onLoad: function() {
      roarLookbook.buildLookbook();
    }
  });

  return LookbookSection;
})();

theme.ProductsSlider = (function() {
  function ProductsSlider(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      finished: false,
      cache: {},
      grid_num: 4,
      grid_row: 1,
      max_pages: 1,
      next_page: 1,
      cat_id: false,
      storage_id: false,
      storage_data: [],
      atts: {}
    };
    
    this.selectors = {
      slider: '.slick-slider-' + sectionId + ':not(.slick-initialized)'
    };

    this._initSlider();
  }

  ProductsSlider.prototype = _.assignIn({}, ProductsSlider.prototype, {
    _isEditor: function() {
      return (window !== window.parent && window.top.location.pathname.indexOf('/admin') >= 0 && window.top.location.pathname.indexOf('/editor') >= 0) ? true : false;
    },
    
    _initSlider: function(evt) {
      
      var self = this;
      var that = $(self.selectors.slider);
      
      self.settings.atts = eval('({' + that.data('atts') + '})');
      self.settings.max_pages = that.data('max_pages');
      self.settings.cat_id = that.data('cat_id');
      self.settings.storage_id = that.data('storage_id');
      self.settings.storage_data = [];

      if (typeof self.settings.cat_id == "undefined" && typeof self.settings.storage_id == "undefined") {
        return;
      }

      var parent = that.closest('.products-slider');
      self.settings.grid_num = that.data('grid_num');
      self.settings.grid_row = that.data('grid_row');

      if (typeof self.settings.storage_id != "undefined" && self.settings.storage_id.length) {
        
        var storageName = 'roarStorage_' + self.settings.storage_id;
        var items = localStorage.getItem(storageName) || '[]';
        try {
          items = JSON.parse(items);
        }
        catch (error) {
          localStorage.removeItem(storageName);
          items = JSON.parse('[]');
        }

        // What is the product ID on this page.
        var productId = 0;
        if (typeof window.ShopifyAnalytics != "undefined") {
          productId = window.ShopifyAnalytics.meta.product.id;
        }
        else {
          productId = weketingShop.productJson.id;
        }

        // If we are on a product template, we make sure to remove the main product from the related product
        if (items.includes(productId)) {
          items.splice(items.indexOf(productId), 1);
        }
        self.settings.storage_data = items;
        
        var howManyToShow = Math.min(self.settings.storage_data.length, 180);
        if (howManyToShow) {
          if (howManyToShow <= (self.settings.grid_num * self.settings.grid_row)) {
            $('.slick-arrows', parent).remove();
          }
          self._buildSlider();
        }
      }

      if (self.settings.max_pages < 2) {
        return;
      }

      $('.slick-prev', parent).off('click').on('click', function(evt) {
        evt.preventDefault();
        
        if (self._isEditor()) {
          return;
        }

        self.settings.next_page = self.settings.next_page - 1;
        if (self.settings.next_page <= 0) {
          self.settings.next_page = self.settings.max_pages;
        }

        self._buildSlider();
      });

      $('.slick-next', parent).off('click').on('click', function(evt) {
        evt.preventDefault();
        
        if (self._isEditor()) {
          return;
        }

        self.settings.next_page = self.settings.next_page + 1;
        if (self.settings.next_page > self.settings.max_pages) {
          self.settings.next_page = 1;
        }

        self._buildSlider();
      });
      
      $(window).scroll(function() {
        var y = 50;
        var u = $('.slick-arrows', parent);
        var v = $('.slick-prev', parent);
        var w = $('.slick-next', parent);
        
        var q = $(window).height() / 2;
        var r = $(window).outerWidth(!0);
        var o = parent.outerWidth(!0);
        var i = $(window).scrollTop();
        var j = parent.offset().top - q;
        var k = parent.offset().left - y;
        var l = o + parent.offset().left + y - w.outerWidth();
        var p = v.outerHeight();
        var n = parent.height() - p;
        var m = j + n;
        var attr = 'left';
        if (theme.settings.rtl) {
          attr = 'right';
        }
        
        $(window).width() <= 1024 && (k += 35, l -= 35), v.css(attr, k + "px"), w.css(attr, l + "px"), i < j || i > m ? u.removeClass("show-arrow") : u.addClass("show-arrow")
      });
    },
    
    _buildSlider: function() {
      var self = this;
      
      var called = false;
      var timeout = 1000;
      if (typeof self.settings.cache[self.settings.next_page] == "undefined") {
        if (typeof self.settings.cat_id != "undefined") {
          called = self._ajaxCollection();
        }
        else {
          called = self._ajaxStorage();
        }
        timeout = 0;
      }

      var parent = $(self.selectors.slider).closest('.products-slider');
      parent.addClass('loading');
      $.when(called).done(function() {
        
        setTimeout(function() {
          self._buildProducts();
          self._lineItem();
        }, timeout);
        
        setTimeout(function() {
          parent.removeClass('loading');
        }, timeout + 250);
      });
    },
    
    _ajaxCollection: function() {
      var self = this;
      
      var parent = $(self.selectors.slider).closest('.products-slider');
      if (!parent.hasClass('loading') && !parent.hasClass('finished')) {
        var self = this;
        
        return $.ajax({
          url: '/collections/' + self.settings.cat_id,
          type: 'GET',
          dataType: 'html',
          data: {
            section_id: 'collection-custom',
            limit: self.settings.grid_num + '*' + self.settings.grid_row,
            page: self.settings.next_page,
            type: self.settings.atts.image_ratio + '*' + (self.settings.atts.image_ratio_crop*1) + '*' + (self.settings.atts.image_second*1) + '*' + self.settings.atts.image_overlay + '*' + self.settings.atts.product_hover + '*' + (self.settings.atts.vendor*1) + '*' + (self.settings.atts.review*1) + '*' + (self.settings.atts.quickview*1) + '*' + (self.settings.atts.wishlist*1) + '*' + (self.settings.atts.compare*1),
            cache: false
          },
          success: function(response) {
            if ($(response).find('.product').length) {
              self.settings.cache[self.settings.next_page] = response;

              if ($(response).data('is_next') == false) {
                self.settings.finished = true;
                for (var i = 1; i <= self.settings.next_page; i++) {
                  if (typeof self.settings.cache[i] == "undefined") {
                    self.settings.finished = false;
                  }
                }
              }

              self._buildProducts();
            }
            else {
              self.settings.finished = true;
            }
            
            if (self.settings.finished) {
              parent.addClass('finished');
            }
          }
        });
      }
      return;
    },
    
    _ajaxStorage: function() {
      var self = this;
      
      var parent = $(self.selectors.slider).closest('.products-slider');
      if (!parent.hasClass('loading') && !parent.hasClass('finished')) {
        var self = this;
        var howmany = self.settings.grid_num * self.settings.grid_row;
        var index = (self.settings.next_page - 1) * howmany;
        var items = self.settings.storage_data.splice(index, howmany);
        
        var ids = items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');

        return $.ajax({
          url:  '/search',
          data: { view: 'viewed', type: 'product', q: ids },
          dataType: 'html',
          type: 'GET',
          success: function(response) {
            if ($(response).find('.product').length) {
              self.settings.cache[self.settings.next_page] = response;
              parent.closest('.products-slider_hide').removeClass('hide');

              if (self.settings.storage_data.length == 0) {
                self.settings.finished = true;
                for (var i = 1; i <= self.settings.next_page; i++) {
                  if (typeof self.settings.cache[i] == "undefined") {
                    self.settings.finished = false;
                  }
                }
              }
              
              self._buildProducts();
            }
            else {
              self.settings.finished = true;
            }
            
            if (self.settings.finished) {
              parent.addClass('finished');
            }
          }
        });
      }
      return;
    },
    
    _buildProducts: function() {
      var self = this;
      
      var parent = $(self.selectors.slider).closest('.products-slider');
      var response = $(self.settings.cache[self.settings.next_page]);
      var products = parent.find('.products');
      
      
      // destroy countdown
      if ($.fn.countdown) {
        products.find('.product__countdown .is-countdown').each(function() {
          $(this).countdown('destroy');
        });
      }

      products.empty();

      if (response.find('.product').length > 0) {
        // detroy lazyload
        response.find('.product__image').removeClass('lazyloaded').removeClass('lazyloading').addClass('lazyload');

        response.find('.product').each(function() {
          products.append($(this));
        });
      }
    },
    
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.splitText();
      theme.roarJs.animationProduct();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    }
  });

  return ProductsSlider;
})();

theme.ProductTabs = (function() {
  function ProductTabs(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      container: '.tabs__container',
      title: '.tabs__title',
      panel: '.tabs__panel'
    };

    this._initTabs();
    this._productsSlider();
  }

  ProductTabs.prototype = _.assignIn({}, ProductTabs.prototype, {
    _initTabs: function(evt) {
      var self = this;

      $(document).off('click', self.selectors.title);
      $(document).on('click', self.selectors.title, function(evt) {
        evt.preventDefault();

        var that = $(this);
        var parent = that.closest(self.selectors.container);
        var panel = $(that.attr('href'));
        var slider = panel.find('.slick-slider');
        var titles = parent.find(self.selectors.title);
        var panels = parent.find(self.selectors.panel);

        titles.removeClass('active');
        panels.removeClass('active');

        that.addClass('active');
        panel.addClass('active');

        if (slider.hasClass('slick-initialized')) {
          slider.slick('setPosition');
        }
      });
    },
    
    _productsSlider: function() {
      var sections = new theme.Sections();
      sections.register('products-slider-sub', theme.ProductsSlider);
    },
    
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    }
  });

  return ProductTabs;
})();

theme.RichBanner = (function() {
  function RichBanner(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    this.selectors = {
      bannerId: '#shopify-section-' + sectionId,
      bannerNamspace: '#rich-banners-' + sectionId,
      bannerAnime: '#rich-banners-' + sectionId + ' .has--anime-fx',
      bannerTilter: '#rich-banners-' + sectionId + ' .has--tilt-effect',
      bannerSlider: '#rich-banners-' + sectionId + ' .rich-banner--group.is-slick_slider',
    };
    
    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      sliderActive: false,
    };

    this._initBreakpoints();
    this._initAnime();
    this._initTilter();
  }

  RichBanner.prototype = _.assignIn({}, RichBanner.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          if (self.settings.sliderActive) {
            self._destroySlider();
          }
          self._initSlider();
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.sliderActive) {
            self._destroySlider();
          }
          self._initSlider(false);
        }
      });
    },
    
    _destroySlider: function() {
      var self = this;
      
      $(self.selectors.bannerSlider).each(function() {
        var that = $(this);
        
        var slick = that.find('.rich-banner--slider.slick-initialized');
        slick.slick('unslick');
        self.settings.sliderActive = false;
      });
    },
    
    _initSlider: function(mobile) {
      var self = this;
      
      $(self.selectors.bannerSlider).each(function() {
        var that = $(this);
        
        if (typeof mobile == "undefined") {
          mobile = true;
        }
        
        var slick = that.find('.rich-banner--slider:not(.slick-initialized)');
        var options = {
          rtl: theme.settings.rtl,
          dots: !1,
          arrows: !0,
          slidesToScroll: 1,
          slidesToShow: that.data('per_slide'),
          autoplay: that.data('autoplay'),
          autoplaySpeed: that.data('interval'),
          variableWidth: that.data('variable_width'),
          centerMode: that.data('variable_width'),
          appendArrows: $('.slick-arrows', slick.parent()),
          prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-prev"></use></svg></button>',
          nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-next"></use></svg></button>',
        };
        
        if (mobile == true) {
          options.slidesToShow = that.data('per_slide_mb');
        }
        
        slick.slick(options);
        self.settings.sliderActive = true;
      });
    },
    
    _initTilter: function() {
      $(this.selectors.bannerTilter).each(function() {
        var that = $(this);
        
        that.on('mousemove', function(e) {
          var left = $(this).offset().left;
          var top = $(this).offset().top;
          var cursPosX = e.pageX - left;
          var cursPosY = e.pageY - top;
          var cursFromCenterX = $(this).width() / 2 - cursPosX;
          var cursFromCenterY = $(this).height() / 2 - cursPosY;
          $(this).css('transform', 'perspective(500px) rotateX('+ (cursFromCenterY / 40) +'deg) rotateY('+ -(cursFromCenterX / 40) +'deg) translateZ(10px)');
          var invertedX = Math.sign(cursFromCenterX) > 0 ? -Math.abs( cursFromCenterX ) : Math.abs( cursFromCenterX );
          $(this).removeClass('tilt-leave');
        });

        that.on('mouseleave', function() {
          $(this).addClass('tilt-leave');
        });
      });
    },
    
    _initAnime: function() {
      $(this.selectors.bannerAnime).each(function() {
        var that = $(this);
        
        var fx_options = {
          used: that.data('fx'),
          type: that.data('fx_type')
        };
        
        if (fx_options.used) {
          if (fx_options.type == 'dominos') {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__dominos .letter').toArray(),
              rotateY: [-90, 0],
              duration: 1300,
              delay: function(el, i) {
                return 45 * i;
              }
            }).add({
              targets: that.find('.fx__dominos').toArray(),
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
          } else if (fx_options.type == 'vertical-lines') {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__vertical-lines .letter').toArray(),
              scale: [0.3,1],
              opacity: [0,1],
              translateZ: 0,
              easing: "easeOutExpo",
              duration: 600,
              delay: function(el, i) {
                return 70 * (i+1)
              }
            }).add({
              targets: that.find('.fx__vertical-lines .line').toArray(),
              scaleX: [0,1],
              opacity: [0.5,1],
              easing: "easeOutExpo",
              duration: 700,
              offset: '-=875',
              delay: function(el, i, l) {
                return 80 * (l - i);
              }
            }).add({
              targets: that.find('.fx__vertical-lines').toArray(),
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
          } else if (fx_options.type == 'fading') {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__fading .letter').toArray(),
              opacity: [0,1],
              easing: "easeInOutQuad",
              duration: 2250,
              delay: function(el, i) {
                return 150 * (i+1)
              }
            }).add({
              targets: that.find('.fx__fading').toArray(),
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
          } else if (fx_options.type == 'intro') {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__intro .letter').toArray(),
              translateX: [40,0],
              translateZ: 0,
              opacity: [0,1],
              easing: "easeOutExpo",
              duration: 1200,
              delay: function(el, i) {
                return 500 + 30 * i;
              }
            }).add({
              targets: that.find('.fx__intro .letter').toArray(),
              translateX: [0,-30],
              opacity: [1,0],
              easing: "easeInExpo",
              duration: 1100,
              delay: function(el, i) {
                return 100 + 30 * i;
              }
            });
          } else if (fx_options.type == 'surprising') {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__surprising .word').toArray(),
              scale: [14,1],
              opacity: [0,1],
              easing: "easeOutCirc",
              duration: 800,
              delay: function(el, i) {
                return 800 * i;
              }
            }).add({
              targets: that.find('.fx__surprising').toArray(),
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
          } else {
            anime.timeline({loop: true})
            .add({
              targets: that.find('.fx__typing .line').toArray(),
              scaleY: [0,1],
              opacity: [0.5,1],
              easing: "easeOutExpo",
              duration: 700
            })
            .add({
              targets: that.find('.fx__typing .line').toArray(),
              translateX: [0, that.find(".fx__typing .letters").first().width()],
              easing: "easeOutExpo",
              duration: 700,
              delay: 100
            }).add({
              targets: that.find('.fx__typing .letter').toArray(),
              opacity: [0,1],
              easing: "easeOutExpo",
              duration: 600,
              offset: '-=775',
              delay: function(el, i) {
                return 34 * (i+1)
              }
            }).add({
              targets: that.find('.fx__typing').toArray(),
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
          } 
        }
      });
    },
    
    _lineItem: function() {
      theme.roarJs.initReviews();
      theme.roarJs.fixtooltipHover();

      // for product item
      var sections = new theme.Sections();
      sections.register('line_item', theme.LineItem);
      sections.register('countdown-timer', theme.CountdownTimer);
    },
    
    onLoad: function() {
      this._lineItem();
    },
    
    onUnload: function(evt) {
      this.$container.off(this.bannerNamspace);
    }
  });
  return RichBanner;
})();

theme.CollectionsSlider = (function() {
  function CollectionsSlider(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    this.selectors = {
      container: '#CollectionsSlider-' + sectionId,
      carousel: '#CollectionsSlider-' + sectionId + ' .slider_large',
      carousel_small: '#CollectionsSlider-' + sectionId + ' .slider_small',
      carousel_content: '#CollectionsSlider-' + sectionId + ' .slider_content-wrapper',
    };

    this.beforeInit();
    this.init();
  }

  CollectionsSlider.prototype = _.assignIn({}, CollectionsSlider.prototype, {
    
    beforeInit: function() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      var vh = window.innerHeight * 0.01;

      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', vh +'px');

      // We listen to the resize event
      window.addEventListener('resize', function() {
        // We execute the same script as before
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh +'px');
      });
      
      // add prototype
      if (typeof Flickity.prototype._createPrevNextCells == 'undefined') {
        function changeSlideClasses(slide, method, className) {
          if (!slide) {
            return;
          }
          slide.getCellElements().forEach(function(cellElem) {
            cellElem.classList[method](className);
          });
        }
        
        Flickity.createMethods.push('_createPrevNextCells');

        Flickity.prototype._createPrevNextCells = function() {
          this.on('select', this.setPrevNextCells);
        };

        Flickity.prototype.setPrevNextCells = function() {
          // remove classes
          changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
          changeSlideClasses(this.nextSlide, 'remove', 'is-next');
          
          // set slides
          var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
          var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
          this.previousSlide = this.slides[previousI];
          this.nextSlide = this.slides[nextI];
          
          // add classes
          changeSlideClasses(this.previousSlide, 'add', 'is-previous');
          changeSlideClasses(this.nextSlide, 'add', 'is-next');
        };
      }
    },
    
    init: function() {
      var self = this;
      
      var $carousel = $(self.selectors.carousel),
          $carousel_small = $(self.selectors.carousel_small),
          $carousel_content = $(self.selectors.carousel_content),
          initialIndex = Math.floor($carousel_small.find('.slideshow__slide').length) - 1,
          slider_autoplay = $carousel.data("autoplay"),
          slider_autoplay_speed = $carousel.data("speed"),
          slides = $carousel.find('.slideshow__image'),
          slides_sm = $carousel_small.find('.slideshow__image');

      if (theme.settings.rtl) {
        initialIndex = 1;
      }
      
      var flkty_cn = new Flickity(self.selectors.carousel_content, {
        rightToLeft: theme.settings.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true, 
        autoPlay: slider_autoplay ? slider_autoplay_speed : false,  
        draggable: false,  
        setGallerySize: false,
        sync: self.selectors.carousel,
        arrowShape: 'M3.1,28.9 28.6,3.4 32.9,7.7 14.7,25.9 68.1,25.9 68.1,32 14.7,32 32.9,50.2 28.6,54.5 z',
        on: {
          ready: function() {
          }
        }           
      });
      
      var flkty_sm = new Flickity (self.selectors.carousel_small, {
        rightToLeft: theme.settings.rtl,
        bgLazyLoad: 1,
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: false,   
        wrapAround: true, 
        autoPlay: slider_autoplay ? slider_autoplay_speed : false,  
        draggable: false,  
        setGallerySize: false,
        initialIndex: initialIndex,
        on: {
          ready: function() {
            var tl = new TimelineLite(),
                slider_wrapper = $carousel_small.find('.flickity-slider');

            tl.fromTo(slider_wrapper, 2, {scale:1.2}, {ease: Power4.easeInOut, scale:1}, 0);
          }
        }           
      });
      
      flkty_sm.on('scroll', function () {
        flkty_sm.slides.forEach(function (slide, i) {
          var image = slides_sm[i],    
              x = 0;

          if (image) {
            if( 0 === i ) {
              x = Math.abs( flkty_sm.x ) > flkty_sm.slidesWidth ? ( flkty_sm.slidesWidth + flkty_sm.x + flkty_sm.slides[flkty_sm.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flkty_sm.x );
            } else if( i === flkty.slides.length - 1 ) {
              x = Math.abs( flkty_sm.x ) + flkty_sm.slides[i].outerWidth < flkty_sm.slidesWidth ? ( slide.target - flkty_sm.slidesWidth + flkty_sm.x - flkty_sm.slides[i].outerWidth ) : ( slide.target + flkty_sm.x );
            } else {
              x = slide.target + flkty_sm.x;
            }
            
            if (typeof window.mobileCheck != 'undefined' && !window.mobileCheck() && !theme.settings.rtl) {
              image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
            }
          }
        });
      });
      
      var flkty = new Flickity(self.selectors.carousel, {
        rightToLeft: theme.settings.rtl,
        bgLazyLoad: 1,
        imagesLoaded: true,
        accessibility: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        wrapAround: true,     
        setGallerySize: false,
        sync: self.selectors.carousel_content,
        autoPlay: slider_autoplay ? slider_autoplay_speed : false,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15
        },
        on: {
          ready: function() {

            var tl = new TimelineLite(),
                slider_wrapper = $carousel.find('.flickity-slider'),
                slider_content = $carousel.find('.slider-content-wrapper'),
                slider_arrows = $carousel.find('.flickity-button svg'),
                slider_dots = $carousel.find('.flickity-page-dots');

            tl.fromTo(slider_wrapper, 2, {scale:1.2}, {ease: Power4.easeInOut, scale:1}, 0);
            tl.fromTo(slider_content, 2.4, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1); 
            tl.fromTo([slider_arrows,slider_dots], 2, {opacity:0}, {ease: Power4.easeInOut, opacity:1}, 1.3); 

          }
        }      
      });
      
      $(document).on('click', self.selectors.carousel_content + ' .flickity-prev-next-button.previous', function () {
        flkty_sm.previous();
      });
      $(document).on('click', self.selectors.carousel_content + ' .flickity-prev-next-button.next', function () {
        flkty_sm.next();
      });
      
      var current_index = null,
          swipe_direction = null;
      
      // Detect swipe direction
      flkty.on( 'dragMove', function( event, pointer, moveVector ) {
        current_index = flkty.selectedIndex;
        swipe_direction = self.getSwipeDirection(moveVector);

        if (slider_autoplay) {
          flkty_sm.stopPlayer()
        }
      });
      
      // Do stuff based on a successful swipe and it's direction
      flkty.on( 'dragEnd', function( touchend ) {
        if (flkty.selectedIndex !== current_index) {
          
          if (swipe_direction === 'left') {
            flkty_sm.next();
          }
          else {
            flkty_sm.previous();
          }
        }
      });
      
      $(self.selectors.container).on('mouseenter', function() {
        flkty.stopPlayer();
        flkty_sm.stopPlayer();
        flkty_cn.stopPlayer();
      });
      
      flkty.on('scroll', function () {
        flkty.slides.forEach(function (slide, i) {
          var image = slides[i],    
              x = 0;

          if (image) {
            if( 0 === i ) {
              x = Math.abs( flkty.x ) > flkty.slidesWidth ? ( flkty.slidesWidth + flkty.x + flkty.slides[flkty.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flkty.x );
            } else if( i === flkty.slides.length - 1 ) {
              x = Math.abs( flkty.x ) + flkty.slides[i].outerWidth < flkty.slidesWidth ? ( slide.target - flkty.slidesWidth + flkty.x - flkty.slides[i].outerWidth ) : ( slide.target + flkty.x );
            } else {
              x = slide.target + flkty.x;
            }

            if (typeof window.mobileCheck != 'undefined' && !window.mobileCheck() && !theme.settings.rtl) {
              image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
            }
          }
        });
      });
    },
    
    getSwipeDirection: function(moveVector) {
      var swipeDirection = null;

      if (moveVector.x > 0) {
        swipeDirection = 'right';
      }
      else {
        swipeDirection = 'left';
      }

      return swipeDirection;
    },
    
    onSelect: function() {
      if (typeof theme.roarAdminJs != 'undefined') {
        theme.roarAdminJs.refresh();
      }
    },
    
    onLoad: function() {
      
    },
    
    onUnload: function(evt) {
      
    }
  });
  return CollectionsSlider;
})();

var roarLookbook = {
  getSizedImageUrl: function(t, e) {
    var a = document.createElement('a');
    a.href = t;
    if (a.hostname != 'cdn.shopify.com') return t;
    if (null == e) return t;
    if ("master" == e) return roarLookbook.removeProtocol(t);
    var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != i) {
      var a = t.split(i[0]),
          o = i[0];
      return roarLookbook.removeProtocol(a[0] + "_" + e + o)
    }
    return null
  },
  removeProtocol: function(t) {
    return t.replace(/http(s)?:/, "")
  },
  isProductUrl: function(url) {
    var hostname = window.location.hostname;
    var element = document.createElement('a');
    element.href = url;
    if (element.hostname == hostname) return true;
    return false;
  },
  isImageUrl: function(url) {
     return new Promise(function (resolve, reject) {
       var img = new Image();

       $(img).load(function () {
         resolve(true);
       }).error(function () {
         resolve(false);
       }).attr('src', url);
     });
  },
  buildLookbook: function() {
    $('.roarlookbook').each(function(idx) {
      var $this = $(this);
      if (!$this.hasClass('roarlookbook_init')) {
        var $image = $this.find('.image-preview');
        var promise = roarLookbook.isImageUrl($image.attr('src'));
        promise.then(function () {
          var $preview = $this.find('.media__blank-preview');
          $this.addClass('roarlookbook_init');
          $preview.addClass('sfx-fadeIn');
        });
      }
    });
  },
  resetHotspots: function(parent) {
    var items = $('.hotspot', parent);
    var lookbook = parent.attr('data-lookbook');
    items.each(function() {
      var that = $(this);
      var id = that.attr('data-id');
      var hotspot = $('#' + lookbook + '-' + id, parent);
      hotspot.fadeOut('fast', function() {
        hotspot.remove();
        that.removeClass('hotspot_init');
      });
    });
  },
  hotspotPopup: function() {
    $('.roarlookbook').on('click', '.hotspot', function(evt) {
      var _this = $(this);

      if (!_this.hasClass('hotspot_init')) {
        var _parent = _this.closest('.roarlookbook');
        var _id = _this.attr('data-id');
        var _hotspot_id = _this.closest('.roarlookbook').attr('data-lookbook') + '-' + _id;
        var _hotspot = '#' + _this.closest('.roarlookbook').attr('data-lookbook') + '-' + _id;
        var _title = _this.attr('data-title');
        var _image = _this.attr('data-image');
        var _price = _this.attr('data-price');
        var _url = _this.attr('data-url');
        var _template = '';

        if (_title == '' && _url == '') {
          return false;
        }
        _this.addClass('hotspot_loading');
        
        roarLookbook.resetHotspots(_parent);

        _template += '<div id="'+ _hotspot_id +'" class="hotspot-widget hotspot-loading">';
        _template += '<div class="hotspot-content">';
        _template += '<span class="hotspot-close">×</span>';
        _template += '<div class="hotspot-inner">';
        if (_image != '') {
          var _image_element = '<img src="'+ roarLookbook.getSizedImageUrl(_image, '80x') +'" src="'+ roarLookbook.getSizedImageUrl(_image, '300x') +'" data-srcset="'+ roarLookbook.getSizedImageUrl(_image, '300x') +' 1x, '+ roarLookbook.getSizedImageUrl(_image, '600x') +' 2x" alt="" />';
          if (_url != '') {
            _template += '<a href="'+ _url +'">'+ _image_element +'</a>';
          }
          else {
            _template += _image_element;
          }
        }

        if (_title != '') {
          _template += '<h3>';
          if (_url != '') {
            _template += '<a href="'+ _url +'">'+ _title +'</a>';
          }
          else {
            _template += _title;
          }
          _template += '</h3>';
        }
        if (_price != '') {
          _template += '<div class="price"><span class="money">'+ _price +'</span></div>';
          if (roarLookbook.isProductUrl(_url)) {
            _template += '<div class="hotspot-btns">';
            _template += '<div class="hotspot-btn"><a href="'+ _url +'">'+ theme.apps.details +'</a></div>';
            _template += '<div class="hotspot-btn"><a class="roar_add_to_cart" href="'+ _url +'?add-to-cart=true">'+ theme.apps.buyNow +'</a></div>';
            _template += '</div>';
          }
        }
        _template += '</div>';
        _template += '</div>';
        _template += '</div>';

        if (!$(_hotspot).length) {
          _parent.append(_template);
        }
        
        if ($(_hotspot).find('img').length) {
          var _element_img = $(_hotspot).find('img');
          _element_img.attr('src', _element_img.attr('data-src')).removeAttr('data-src').attr('srcset', _element_img.attr('data-srcset')).removeAttr('data-srcset');
        }
        
        var promise = roarLookbook.isImageUrl(_image);
        promise.then(function () {
          setTimeout(function() {
            var _element = $(_hotspot),
                _left = _this.offset().left,
                _top = _this.offset().top,
                _width = _element.outerWidth(),
                _height = _element.outerHeight(),
                _left_p = _parent.offset().left,
                _top_p = _parent.offset().top,
                _width_p = _parent.outerWidth() - (_left + _width),
                _class = 'hotspot-right';
            //if (50 > _width_p) {
            if (_left > (_width + 5)) {
              _left = _left - _width - 5;
              _class = 'hotspot-left';
            }
            else {
              _left = _left + _this.outerWidth() + 5;
            }
            _top = _top + (_this.outerHeight()/2) - (_height/2);

            _element.css({
              left: _left - _left_p,
              top: _top - _top_p
            }).removeClass('hotspot-left').removeClass('hotspot-right').addClass(_class);

            _this.removeClass('hotspot_loading').addClass('hotspot_init');
            _element.removeClass('hotspot-loading').fadeIn('fast');
          }, 600);
        });
      }
      else {
        var _parent = _this.closest('.roarlookbook');
        roarLookbook.resetHotspots(_parent);
      }
    });
    $(document).on('click', '.hotspot-close', function(evt) {
      var _this = $(this);
      var _hotspot = _this.closest('.hotspot-widget');
      var _id = _hotspot.attr('id');
      var _ids = _id.split('-');
      var id = _ids[1];
      
      $('.roarlookbook .hotspot[data-id="'+ id +'"]').removeClass('hotspot_init');
      _hotspot.fadeOut('fast', function() {
        _hotspot.remove();
      });
    });
    $('.roarlookbook').on('click', '.image-preview', function(evt) {
      var _parent = $(this).closest('.roarlookbook');
      roarLookbook.resetHotspots(_parent);
    });
    $(window).resize(function(evt) {
      if ($('.roarlookbook .hotspot_init').length) {
        $('.roarlookbook .hotspot_init').each(function() {
          var _this = $(this);
          _this.removeClass('hotspot_init').trigger('click');
        });
      }
    });
  },
  addToCart: function() {
    $(document).on('click', '.roar_add_to_cart', function(evt) {
      evt.preventDefault();
      
      var that = $(this);
      var lookbook = that.closest('.roarlookbook');
      var url = that.attr('href');
      $.ajax({
        type: 'GET',
        url: url,
        beforeSend: function() {
        },
        success: function(html) {
          var form = $(html).find('form[action="/cart/add"]');
          form.appendTo(lookbook).submit().remove();
        },
        dataType: 'html'
      });
    });
  },
  init: function() {
    if ($('.roarlookbook').length) {
      roarLookbook.buildLookbook();
      roarLookbook.hotspotPopup();
      roarLookbook.addToCart();
    }
  }
};

theme.roarJs = (function() {
  
  function scrollDownAnchor() {
    $(document).off('click', '.section__anchor');
    $(document).on('click', '.section__anchor', function(evt) {
      evt.preventDefault();
      
      var section = $(this).closest('.container-section');
      var position = section.offset().top + section.outerHeight();
      
      if ($('.header-sticky__placeholder').length && !$('.header-sticky__placeholder').hasClass('hide')) {
        position = position - $('.header-sticky__placeholder').outerHeight();
      }
      
      $('html, body').animate({
        scrollTop: position
      }, 500, 'swing');
    });
  }
  
  function tiltHoverEffect() {
    var settings = [
      {},
      {
        movement: {
          imgWrapper : {
            translation : {x: 10, y: 10, z: 30},
            rotation : {x: 0, y: -10, z: 0},
            reverseAnimation : {duration : 200, easing : 'easeOutQuad'}
          },
          lines : {
            translation : {x: 10, y: 10, z: [0,70]},
            rotation : {x: 0, y: 0, z: -2},
            reverseAnimation : {duration : 2000, easing : 'easeOutExpo'}
          },
          caption : {
            rotation : {x: 0, y: 0, z: 2},
            reverseAnimation : {duration : 200, easing : 'easeOutQuad'}
          },
          overlay : {
            translation : {x: 10, y: -10, z: 0},
            rotation : {x: 0, y: 0, z: 2},
            reverseAnimation : {duration : 2000, easing : 'easeOutExpo'}
          },
          shine : {
            translation : {x: 100, y: 100, z: 0},
            reverseAnimation : {duration : 200, easing : 'easeOutQuad'}
          }
        }
      },
      {
        movement: {
          imgWrapper : {
            rotation : {x: -5, y: 10, z: 0},
            reverseAnimation : {duration : 900, easing : 'easeOutCubic'}
          },
          caption : {
            translation : {x: 30, y: 30, z: [0,40]},
            rotation : {x: [0,15], y: 0, z: 0},
            reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
          },
          overlay : {
            translation : {x: 10, y: 10, z: [0,20]},
            reverseAnimation : {duration : 1000, easing : 'easeOutExpo'}
          },
          shine : {
            translation : {x: 100, y: 100, z: 0},
            reverseAnimation : {duration : 900, easing : 'easeOutCubic'}
          }
        }
      },
      {
        movement: {
          imgWrapper : {
            rotation : {x: -5, y: 10, z: 0},
            reverseAnimation : {duration : 50, easing : 'easeOutQuad'}
          },
          caption : {
            translation : {x: 20, y: 20, z: 0},
            reverseAnimation : {duration : 200, easing : 'easeOutQuad'}
          },
          overlay : {
            translation : {x: 5, y: -5, z: 0},
            rotation : {x: 0, y: 0, z: 6},
            reverseAnimation : {duration : 1000, easing : 'easeOutQuad'}
          },
          shine : {
            translation : {x: 50, y: 50, z: 0},
            reverseAnimation : {duration : 50, easing : 'easeOutQuad'}
          }
        }
      },
      {
        movement: {
          imgWrapper : {
            translation : {x: 0, y: -8, z: 0},
            rotation : {x: 3, y: 3, z: 0},
            reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
          },
          lines : {
            translation : {x: 15, y: 15, z: [0,15]},
            reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
          },
          overlay : {
            translation : {x: 0, y: 8, z: 0},
            reverseAnimation : {duration : 600, easing : 'easeOutExpo'}
          },
          caption : {
            translation : {x: 10, y: -15, z: 0},
            reverseAnimation : {duration : 900, easing : 'easeOutExpo'}
          },
          shine : {
            translation : {x: 50, y: 50, z: 0},
            reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
          }
        }
      },
      {
        movement: {
          lines : {
            translation : {x: -5, y: 5, z: 0},
            reverseAnimation : {duration : 1000, easing : 'easeOutExpo'}
          },
          caption : {
            translation : {x: 15, y: 15, z: 0},
            rotation : {x: 0, y: 0, z: 3},
            reverseAnimation : {duration : 1500, easing : 'easeOutElastic', elasticity : 700}
          },
          overlay : {
            translation : {x: 15, y: -15, z: 0},
            reverseAnimation : {duration : 500,easing : 'easeOutExpo'}
          },
          shine : {
            translation : {x: 50, y: 50, z: 0},
            reverseAnimation : {duration : 500, easing : 'easeOutExpo'}
          }
        }
      },
      {
        movement: {
          imgWrapper : {
            translation : {x: 5, y: 5, z: 0},
            reverseAnimation : {duration : 800, easing : 'easeOutQuart'}
          },
          caption : {
            translation : {x: 10, y: 10, z: [0,50]},
            reverseAnimation : {duration : 1000, easing : 'easeOutQuart'}
          },
          shine : {
            translation : {x: 50, y: 50, z: 0},
            reverseAnimation : {duration : 800, easing : 'easeOutQuart'}
          }
        }
      },
      {
        movement: {
          lines : {
            translation : {x: 40, y: 40, z: 0},
            reverseAnimation : {duration : 1500, easing : 'easeOutElastic'}
          },
          caption : {
            translation : {x: 20, y: 20, z: 0},
            rotation : {x: 0, y: 0, z: -5},
            reverseAnimation : {duration : 1000, easing : 'easeOutExpo'}
          },
          overlay : {
            translation : {x: -30, y: -30, z: 0},
            rotation : {x: 0, y: 0, z: 3},
            reverseAnimation : {duration : 750, easing : 'easeOutExpo'}
          },
          shine : {
            translation : {x: 100, y: 100, z: 0},
            reverseAnimation : {duration : 750, easing : 'easeOutExpo'}
          }
        }
      }];

    function init() {
      var idx = 0;
      [].slice.call(document.querySelectorAll('.tilter')).forEach(function(el, pos) { 
        idx = pos%30 === 0 ? idx+1 : idx;
        new TiltFx(el, settings[idx-1]);
      });
    }

    init();
  }

  function pageLoader() {
    if (!$('#site-loader').length) {
      return;
    }

    NProgress.configure({
      template: '<div class="bar" role="bar"></div>',
      parent: '#site-loader',
      showSpinner: false,
      easing: 'ease',
      minimum: 0.3,
      speed: 500,
    });

    NProgress.start();

    $(window).on('pagehide', function(evt) {
      if (evt.persisted) {
        $('#site-container').addClass('loading').removeClass('loaded');
        $('#site-loader').removeClass('loaded');
      }
    });
    
    $(window).load(function(evt) {
      $('#site-container').addClass('loaded').removeClass('loading');
      $('#site-loader').addClass('loaded');
      NProgress.done();
    });
  }

  function ageCheck() {
    function readCookie(name) {
      try {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      } catch(e) {
        return null;
      }
    };

    var isAnAdult = readCookie('roarStorage_isAnAdult');
    if (isAnAdult) {
      $('#age__check').remove();
    }
    else {
      setTimeout(function(){
        $('#age__check').addClass('active');
      }, 2000);
    }

    $(document).off('click', '#age__check .btn-birthdate');
    $(document).on('click', '#age__check .btn-birthdate', function() {
      //number of days until they must go through the age checker again.
      var days = 14;
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      var expires = '; expires=' + date.toGMTString();
      document.cookie = 'roarStorage_isAnAdult=true;' + expires + '; path=/';

      location.reload();
    });


    $(document).off('click', '#age__check .btn-exit');
    $(document).on('click', '#age__check .btn-exit', function() {
      //number of days until they must go through the age checker again.
      var days = 14;
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      var expires = '; expires=' + date.toGMTString();
      document.cookie = 'roarStorage_isAnAdult=true;' + expires + '; path=/';

      location.reload();
    });
  }

  function initReviews() {
    'undefined' != typeof jQuery && 'undefined' != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
  }

  function toggleSidebar() {
    function offcanvas_anim() {
      var tl = new TimelineLite(),
          widget_list = $(".site-sidebar .widget-area"),
          widget_list_item = $(".site-sidebar .site-widget");

      if (theme.settings.rtl) {
        tl.fromTo(widget_list, 1, {autoAlpha: 0}, {autoAlpha: 1, ease: Power0.easeInOut}, .1);
        tl.staggerFromTo(widget_list_item, .5, {opacity:0, skewX:-10, x:40}, {opacity:1, skewX:0, x:0}, .1, 0.2);
      }
      else {
        tl.fromTo(widget_list, 1, {autoAlpha: 0}, {autoAlpha: 1, ease: Power0.easeInOut}, .1);
        tl.staggerFromTo(widget_list_item, .5, {opacity:0, skewX:10, x:-40}, {opacity:1, skewX:0, x:0}, .1, 0.2);		
      }
    }
    
    $(document).off('click', '.sidebar__btn, .sidebar__close, .sidebar__overlay');
    $(document).on('click', '.sidebar__btn, .sidebar__close, .sidebar__overlay', function() {
      if ($('body').hasClass('sidebar-open')) {
        $('body').removeClass('sidebar-open');
      }
      else {
        $('body').addClass('sidebar-open');
        offcanvas_anim();
      }
    });
    $(document).off('click', '.filters__btn');
    $(document).on('click', '.filters__btn', function() {
      $('.shop__filtering').slideToggle();
    });
  }

  function toggleCategories() {
    $(document).off('click', '.header__toggle');
    $(document).on('click', '.header__toggle', function() {
      $(this).toggleClass('active');
      $('.collection-header ul').slideToggle();
    });
  }

  function initAlert() {
    $(document).off('click', '.alert-message');
    $(document).on('click', '.alert-message', function() {
      $(this).hide();

      var delay = 0;
      var afterAddition = theme.settings.afterAddition;
      if ($('body').hasClass('quickview-opened')) {
        afterAddition = 'message';
        delay = 300;
        $('.cd-quick-view .cd-close').trigger('click');
      }
      if ($(this).hasClass('cart_message') && afterAddition == 'message') {
        setTimeout(function() {
          theme.MiniCart.open();
        }, delay);
      }
    });
  }

  function openAlert(icon, content, background) {
    if (typeof background == "undefined") {
      background = false;
    }
    $('.alert-message').remove();

    var alert = '<div class="alert alert-'+ (icon == "check" ? "success" : "error") +' alert-message"><div class="alert__icon"><i class="ris ri-'+ icon +'"></i></div><div class="alert__content">'+ content +'</div></div>';

    if (background == true) {
      alert = '<div class="alert alert-message cart_message"><div class="alert__background" style="background-image:url('+ icon +');"></div><div class="alert__description">' + content + '</div></div>';
    }

    $('body').append(alert);
  }
  
  function productColors() {
    if (!$('.product__colors .swatch-item').length) {
      return false;
    }
    
    $(document).off('click', '.product__colors .swatch-item');
    $(document).on('click', '.product__colors .swatch-item', function(evt) {
      evt.preventDefault();
      
      var that = $(this);
      if (!that.hasClass('active')) {
        var $image = that.closest('.product__item').find('.product__image-featured');
        var bgset = that.data('bgset');
        $image.attr('data-bgset', bgset).removeClass('lazyloaded').addClass('lazyload');

        that.closest('.product__colors').find('.swatch-item').removeClass('active');
        that.addClass('active');
      }
    });
  }

  function quickView() {
    if (!$('.quickview_btn').length) {
      return false;
    }

    $(document).off('click', '.quickview_btn');
    $(document).on('click', '.quickview_btn', function(evt) {
      evt.preventDefault();

      var that = $(this);
      var collection_handle = that.data('collection_handle');
      var product_handle = that.data('product_handle');
      var product_image = that.closest('.product__item');
      var selected_image = product_image.find('.product__image');
      var selected_image_url = selected_image.css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');

      $.ajax({
        url: '/collections/'+ collection_handle +'/products/'+ product_handle +'?section_id=product-quickview-template&cache=false',
        beforeSend: function() {
          that.addClass('adding');
        },
        complete: function() {
          that.removeClass('adding');
        },
        success: function(response) {
          $('.cd-quick-view .cd-content').empty().html(response);
          
          setTimeout(function() {
            $('.cd-quick-view').addClass('opened');
          }, 300);

          setTimeout(function() {
            $('body').addClass('blurred').addClass('quickview-opened');
          }, 500);
          
          theme.roarJs.productInfoAnimation($('.cd-quick-view'));
          var sections = new theme.Sections();
          sections.register('product-quickview', theme.Product);
          Shopify.PaymentButton.init();
        }
      });
    });
    
    $(document).off('click', '.cd-close, .cd-overlay');
    $(document).on('click', '.cd-close, .cd-overlay', function() {
      $('body').removeClass('blurred').removeClass('quickview-opened');
      $('.cd-quick-view').removeClass('opened');
      theme.ProductVideo.removeSectionVideos("product-quickview-template");
      theme.ProductModel.removeSectionModels("product-quickview-template");
    });

    $(document).keyup(function(evt) {
      if (evt.which == '27') {
        if ($('.cd-quick-view').hasClass('opened')) {
          $('.cd-close').trigger('click');
        }
      }
    });
  }

  function optionsCart() {
    $(document).off('click', '.products-grid .product .options_btn');
    $(document).on('click', '.products-grid .product .options_btn', function(evt) {
      evt.preventDefault();
      
      var parent = $(this).closest('.product');
      parent.addClass('opened');
    });
    $(document).off('click', '.products-grid .product .close_btn');
    $(document).on('click', '.products-grid .product .close_btn', function(evt) {
      evt.preventDefault();
      
      var parent = $(this).closest('.product');
      parent.removeClass('opened');
    });
  }

  function addCart() {
    $(document).off('click', '.addcart_btn:not(.added), .product-form__cart-submit');
    $(document).on('click', '.addcart_btn:not(.added), .product-form__cart-submit', function(evt) {
      evt.preventDefault();

      var that = $(this);
      var $form = that.closest('form');
      var $body = $('body');

      if (theme.settings.cartAjax != true){
        $form.submit();
        return false;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: !0,
        cache: !1,
        data: $form.serialize(),
        dataType: 'json',
        beforeSend: function() {
          that.addClass('adding');
        },
        success: function(response) {
          if (theme.settings.afterAddition == 'redirect') {
            window.location = '/cart';
            return false;
          }
          else {
            var promise = theme.MiniCart.update();

            promise.promise().done(function() {
              // animate button
              var delay = 0;
              if (that.hasClass('progress-btn')) {
                delay = 500;
              }
              that.addClass('active');
              setTimeout(function() {
                that.removeClass('adding').text(that.data('added')).addClass('added');
                
                if (delay) {
                  setTimeout(function() {
                    that.removeClass('active').removeClass('added');
                  }, 2000);
                }
              }, delay);

              // display minicart
              var afterAddition = theme.settings.afterAddition;
              var timer = 0;
              if (delay) {
                timer = delay + 800;
              }
              if ($body.hasClass('compare-opened') || $body.hasClass('quickview-opened')) {
                timer = 0;
                afterAddition = 'message';
              }

              setTimeout(function() {
                switch(afterAddition) {
                  case 'minicart':
                    theme.MiniCart.open();
                    break;
                  case 'message':
                    var json = response;

                    if (json.id !== undefined) {
                      var image = theme.Images.getSizedImageUrl(json.image, '200x');
                      var title = json.title;
                      var message = (theme.strings.productAdded).replace('{{ product_name }}', title);
                      openAlert(image, message, true);
                    }
                    else {
                      var message = json.message + ": " + json.description;
                      openAlert('alert', message);
                    }
                    break;
                }
              }, timer);
            });
          }
        }
      });

      return false;
    });

    $(document).off('click', '.product-form__cart-submit--grouped');
    $(document).on('click', '.product-form__cart-submit--grouped', function(evt) {
      evt.preventDefault();

      var that = $(this);
      var quantities = that.closest('.product-single__content').find('.product-single__grouped .product-form__input');

      if (quantities.length) {
        Shopify.queue = [];

        quantities.each(function() {
          if (parseInt($(this).val()) > 0) {
            Shopify.queue.push({
              variantId: $(this).data('variant_id'),
              quantity: parseInt($(this).val())
            });
          }
        });

        Shopify.moveAlong = function() {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
          }
          else {
            that.removeClass('adding');
            theme.MiniCart.update();

            if (theme.settings.afterAddition == 'redirect') {
              location.href = '/cart';
            }
            else if (theme.settings.afterAddition == 'minicart') {
              theme.MiniCart.open();
            }
          }
        };
        Shopify.addItem = function(id, qty, properties, callback) {
          var params = {
            quantity: qty,
            id: id
          };

          if (properties != false) {
            params.properties = properties;
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,
            success: function() {
              if (typeof callback === 'function') {
                callback();
              }
            },
            error: function() {
              //
            }
          });
        };

        if (Shopify.queue.length) {
          that.addClass('adding');
          Shopify.moveAlong();
        }
      }

      return false;
    });
  }

  function addWishlist() {
    if (!$('.addwishlist_btn').length) {
      return false;
    }
    
    $(document).off('click', '.addwishlist_btn:not(.added)');
    $(document).on('click', '.addwishlist_btn:not(.added)', function(evt) {
      evt.preventDefault();

      var that = $(this);
      var customer_id = parseInt(that.data('customer_id'));

      if (customer_id > 0) {
        var shop_id = that.data('shop_domain');
        var product_id = parseInt(that.data('product_id'));
        var product_handle = that.data('product_handle').toString();

        if (shop_id.length && product_handle.length && product_id) {
          var form = document.createElement('form');
          form.setAttribute('action', '/contact');
          form.setAttribute('method', 'POST');
          form.setAttribute('style', 'display:none');

          var input_customer = document.createElement('input');
          input_customer.setAttribute('type', 'hidden');
          input_customer.setAttribute('name', 'customer');
          input_customer.setAttribute('value', customer_id);

          var input_shop = document.createElement('input');
          input_shop.setAttribute('type', 'hidden');
          input_shop.setAttribute('name', 'shop');
          input_shop.setAttribute('value', shop_id);

          var input_id = document.createElement('input');
          input_id.setAttribute('type', 'hidden');
          input_id.setAttribute('name', 'id');
          input_id.setAttribute('value', product_id);

          var input_handle = document.createElement('input');
          input_handle.setAttribute('type', 'hidden');
          input_handle.setAttribute('name', 'handle');
          input_handle.setAttribute('value', product_handle);

          var input_action = document.createElement('input');
          input_action.setAttribute('type', 'hidden');
          input_action.setAttribute('name', 'action');
          input_action.setAttribute('value', 'add_wishlist');

          form.appendChild(input_customer);
          form.appendChild(input_shop);
          form.appendChild(input_id);
          form.appendChild(input_handle);
          form.appendChild(input_action);

          $('body').append(form);

          var data = $(form).serialize();
          $.ajax({
            type: "POST",
            url: "/a/wishlist",
            async: !0,
            cache: !1,
            data: data,
            dataType: "json",
            beforeSend: function() {
              that.addClass('adding');
            },
            complete: function() {
              that.removeClass('adding');
            },
            success: function(response) {
              openAlert('check', theme.strings.wishlistAdded);

              that.addClass('added').find('.tooltip').text(that.data('added'));
              $(form).remove();

              if(response['code'] == 1 ) {
                var count = parseInt(response['json']);
                if (count) {
                  $('.wishlist__count').removeClass('hide').text(count);
                }
                else {
                  $('.wishlist__count').addClass('hide').text(0);
                }
              }
            }
          });
        }
      }
      else {
        window.location = '/account/login';
      }
    });
  }

  function removeWishlist() {
    if (!$('.removewishlist_btn').length) {
      return false;
    }
    
    $(document).off('click', '.removewishlist_btn');
    $(document).on('click', '.removewishlist_btn', function() {
      var that = $(this);
      var customer_id = parseInt(that.data('customer_id'));

      if (customer_id > 0) {
        var shop_id = that.data('shop_domain');
        var product_id = parseInt(that.data('product_id'));

        if (shop_id.length && product_id) {
          var form = document.createElement('form');
          form.setAttribute('action', '/contact');
          form.setAttribute('method', 'POST');
          form.setAttribute('style', 'display:none');

          var input_customer = document.createElement('input');
          input_customer.setAttribute('type', 'hidden');
          input_customer.setAttribute('name', 'customer');
          input_customer.setAttribute('value', customer_id);

          var input_shop = document.createElement('input');
          input_shop.setAttribute('type', 'hidden');
          input_shop.setAttribute('name', 'shop');
          input_shop.setAttribute('value', shop_id);

          var input_id = document.createElement('input');
          input_id.setAttribute('type', 'hidden');
          input_id.setAttribute('name', 'product');
          input_id.setAttribute('value', product_id);

          var input_action = document.createElement('input');
          input_action.setAttribute('type', 'hidden');
          input_action.setAttribute('name', 'action');
          input_action.setAttribute('value', 'remove_wishlist');

          form.appendChild(input_customer);
          form.appendChild(input_shop);
          form.appendChild(input_id);
          form.appendChild(input_action);

          $('body').append(form);

          var data = $(form).serialize();
          $.ajax({
            type: "POST",
            url: "/a/wishlist",
            async: !0,
            cache: !1,
            data: data,
            dataType: "json",
            beforeSend: function() {
              $('.wishlist__table').addClass('loading');
            },
            complete: function() {
              $('.wishlist__table').removeClass('loading');
            },
            success: function(response) {
              $(form).remove();

              if(response['code'] == 1 ) {
                var count = parseInt(response['json']);
                if (count) {
                  that.closest('tr').slideUp('fast', function(){
                    $(this).remove();

                    openAlert('check', theme.strings.wishlistRemoved);
                    $('.wishlist__count').removeClass('hide').text(count);
                  });
                }
                else {
                  location.reload();
                }
              }
            }
          });
        }
      }
      else {
        window.location = '/account/login';
      }
    });
  }
  
  function loadWishlist() {
    if (!$('.page-wishlist .ajax_load_button .loadmore').length) {
      return false;
    }
    
    $(document).off('click', '.page-wishlist .ajax_load_button .loadmore');
    $(document).on('click', '.page-wishlist .ajax_load_button .loadmore', function() {
      var that = '.page-wishlist .ajax_load_button .loadmore';
      var parent = '.page-wishlist .ajax_load_button';
      var product = '.page-wishlist .wishlist__item';
      var pagination = '.page-wishlist .pagination';

      if ($(pagination).find('a.next').length) {
        $(that).attr('data-processing', 1);

        var url = $(pagination).find('a.next').attr('href');
        var no_more = $(that).data('no_more');

        $(parent).addClass('loading');

        $.get(url, function(response) {
          $(pagination).empty().html($(response).find(pagination).html());

          $(response).find(product).each(function() {
            $(product).last().after($(this));
          });

          $(parent).removeClass('loading');
          $(that).attr('data-processing', 0);

          if ($(pagination).find('a.next').length == 0) {
            $(parent).addClass('ajax_load_finished').removeClass('ajax_load_hidden');		                
            $(that).show().html(no_more).addClass('disabled').prop('disabled', true);
          }
        });
      }
      else {
        var no_more = $(that).attr('data-no-more');
        $(parent).addClass('ajax_load_finished').removeClass('ajax_load_hidden');		                
        $(that).show().html(no_more).addClass('disabled').prop('disabled', true);
      }
    });
  }

  function openCompare(content) {
    var body = $('body');
    body.addClass('compare-opened');

    var compare = $('.compare__modal');
    compare.removeClass('opened');
    if (content && content.length) {
      compare.find('.compare__content').empty().html(content);
    }
    compare.addClass('opened');

    // repaire compare list
    $('.compare__list tr').each(function() {
      $(this).css('height', $(this).outerHeight());
    });
    $('.compare__list').clone().appendTo('.compare__left');
    $('.compare__left td').remove();
  }
  
  function closeCompare() {
    var body = $('body');
    body.removeClass('compare-opened');

    var compare = $('.compare__modal');
    compare.removeClass('opened');
  }

  function getCompareData() {
    var storageName = 'roarStorage_compare';
    var items = localStorage.getItem(storageName) || '[]';
    try {
      items = JSON.parse(items);
    }
    catch (error) {
      localStorage.removeItem(storageName);
      items = JSON.parse('[]');
    }

    // Remove null item
    var filtered = items.filter(function (item) {
      return item != null;
    });

    return filtered.length > 10 ? filtered.slice(0, 10) : filtered;
  }

  function setCompareData(items) {
    var storageName = 'roarStorage_compare';
    var filtered = items.length > 10 ? items.slice(0, 10) : items;

    try {
      localStorage.setItem(storageName, JSON.stringify(filtered));
    }
    catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }

    return filtered;
  }

  function setCompareCount() {
    var items = getCompareData();
    var $compareLink = $('.compare__link');
    var $compareCount = $('.compare__count');
    
    if ($compareCount.length > 0) {
      var count = items.length;

      $compareCount.text(count);
      if (count > 0) {
        $compareCount.removeClass('hide');
        $compareLink.removeClass('deactive');
      }
      else {
        $compareCount.addClass('hide');
        $compareLink.addClass('deactive');
      }
    }
  }

  function initCompare() {
    var items = getCompareData();
    
    if (items.length) {
      $('.addcompare_btn').each(function() {
        var that = $(this);
        var productId = that.data('product_id');
        
        if (items.includes(productId)) {
          that.addClass('added').find('.tooltip').text(that.data('added'));
        }
      });
    }

    // Set count
    setCompareCount();

    // Events
    $(document).off('click', '.compare__close');
    $(document).on('click', '.compare__close', function() {
      closeCompare();
    });

    $(document).keyup(function(evt) {
      if (evt.which == '27') {
        if ($('.compare__modal').hasClass('opened')) {
          closeCompare();
        }
      }
    });

    $(document).off('click', '.compare__link');
    $(document).on('click', '.compare__link', function() {
      var that = $(this);
      var items = getCompareData();

      var ids = items.map(function (item) {
        return 'id:' + item;
      }).join(' OR ');

      $.ajax({
        url:  '/search',
        data: { view: 'compare', type: 'product', q: ids },
        dataType: 'html',
        type: 'GET',
        beforeSend: function() {
          that.addClass('loading');
        },
        complete: function() {
          that.removeClass('loading');
        },
        success: function(response) {
          openCompare(response);

          // Set count
          setCompareCount();
        }
      });
    });
  }

  function addCompare() {
    $(document).off('click', '.addcompare_btn');
    $(document).on('click', '.addcompare_btn', function(evt) {
      evt.preventDefault();

      var that = $(this);
      var items = getCompareData();

      // What is the product ID on this page.
      var productId = that.data('product_id');

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }
      
      // Show message if more than limit
      if (items.length >= 10) {
        openAlert('alert', theme.strings.compareLimit);
      }

      // Then, we save the current product into the local storage
      var filtered = setCompareData(items);

      var ids = filtered.map(function (item) {
        return 'id:' + item;
      }).join(' OR ');

      $.ajax({
        url:  '/search',
        data: { view: 'compare', type: 'product', q: ids },
        dataType: 'html',
        type: 'GET',
        beforeSend: function() {
          that.removeClass('added').addClass('adding');
        },
        complete: function() {
          that.removeClass('adding');
        },
        success: function(response) {
          openCompare(response);
          that.addClass('added').find('.tooltip').text(that.data('added'));

          // Set count
          setCompareCount();
        }
      });
    });
  }

  function removeCompare() {
    $(document).off('click', '.removecompare_btn');
    $(document).on('click', '.removecompare_btn', function(evt) {
      evt.preventDefault();
      
      var that = $(this);
      var productId = that.data('product_id');
      var productClass = '.product__' + productId;
      var items = getCompareData();
      
      // We check if the current product already exists, and if it does, we remove it
      if (items.includes(productId)) {
        items.splice(items.indexOf(productId), 1);
      }
      
      // Then, we save the current product into the local storage
      var filtered = setCompareData(items);
      
      if (filtered.length) {
        $('.compare__list ' + productClass).remove();
      }
      else {
        closeCompare();
      }
      var that = $(productClass + ' .addcompare_btn');
      that.removeClass('added').find('.tooltip').text(that.data('tooltip'));

      // Set count
      setCompareCount();
    });
  }

  function shortcodes() {
    $('.slick__gallery').each(function() {
      var that = $(this);

      that.slick({
        rtl: theme.settings.rtl,
        prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-prev"></use></svg></button>',
        nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-next"></use></svg></button>',
      });
    });

    $('.soundcloud__audio').each(function() {
      var that = $(this);
      var video = that.data('video');

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://soundcloud.com/oembed",
        "method": "GET",
        "headers": {},
        "data": {
          "format": "json",
          "url": video
        }
      }

      $.ajax(settings).done(function (response) {
        that.replaceWith(response.html);
      });
    });
  }

  function backHistory() {
    history.go(-1);
  }

  function passwordPage() {
    $(document).off('click', '.password-login');
    $(document).on('click', '.password-login', function(evt) {
      evt.preventDefault();

      $('body').addClass('password-opened');
      setTimeout(function() {
        $('.password-modal input').focus();
      }, 250);
    });

    $(document).off('click', '.password-modal .modal__close, .password__overlay');
    $(document).on('click', '.password-modal .modal__close, .password__overlay', function() {
      $('body').removeClass('password-opened');
    });

    $(document).keyup(function(evt) {
      if (evt.keyCode == 27) {
        $('body').removeClass('password-opened');
      }
    });

    // Open modal if errors exist
    if ($('.password-modal').find('.errors').length) {
      $('body').addClass('password-opened');
      setTimeout(function() {
        $('.password-modal input').focus();
      }, 250);
    }
  }

  function ajaxComplete() {
    function checkArray(str, arr){
      for(var i=0; i < arr.length; i++){
        if(str.match((".*" + arr[i].trim() + ".*").replace(" ", ".*")))
          return true;
      }
      return false;
    }

    // ajax calls
    var ajaxAllowed = ['/cart?', '/search?', '/collections/'];
    $(document).ajaxComplete(function(evt, xhr, settings) {
      var url = settings.url;

      if (checkArray(url, ajaxAllowed)) {
        theme.roarJs.initReviews();
        theme.roarJs.splitText();
        theme.roarJs.animationProduct();
        theme.roarJs.fixtooltipHover();

        // for product item
        var sections = new theme.Sections();
        sections.register('line_item', theme.LineItem);
        sections.register('countdown-timer', theme.CountdownTimer);
      }
    });
  }

  function initLookbook() {
    if ($('.lookbook-section.is-slick_slider .lookbook-listing').length) {
      $('.lookbook-section.is-slick_slider .lookbook-listing').each(function() {
        var that = $(this);
        var options = {
          rtl: theme.settings.rtl,
          centerMode: true,
          centerPadding: '20%',
          slidesToShow: 1,
          appendArrows: $('.slick-arrows', that.parent()),
          prevArrow: '<button class="slick-prev" type="button" aria-label="Previous slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-prev"></use></svg></button>',
          nextArrow: '<button class="slick-next" type="button" aria-label="Next slide"><svg class="svg-icon" aria-hidden="true"><use xlink:href="#global__symbols-next"></use></svg></button>',
        };
        var number = that.find('.lookbook__item').length;

        var interval = setInterval(function() {
          var num = that.find('img.image-preview').length;
          if (number <= num) {
            that.imagesLoaded(function() {
              setTimeout(function() {
                that.slick(options);
              }, 500);
            });
            clearInterval(interval);
          }
        }, 300);
      });
    }
  }
  
  function footerInit() {
    function footerRevealCalcs() {
      var $headerNavSpace = $('.page-header').outerHeight();
      var $windowHeight = $(window).height();
      var $footerHeight = $('#site-footer').height();
      
      if ($windowHeight - $headerNavSpace - $footerHeight > 0) {
        $('#site-content').css({
          'min-height': $windowHeight - $headerNavSpace - $footerHeight - 1
        });
        $('#site-container').css({
          'margin-bottom': $footerHeight - 1
        });
      } else {
        $('#site-container').css({
          'margin-bottom': $footerHeight - 1
        });
      }
    }
    if ($("#site-footer").hasClass("is-reveal")) {
      footerRevealCalcs();
      $(window).resize(function() {
        footerRevealCalcs();
      });
    }
  }

  function backtoTop() {
    var section = $('.progress-section');
    var element = $('.progress-page');

    if (!element.length || !section.length) {
      return;
    }
    
    section.append(element);
    
    $('.scrolltotop').on('click', function() {
      $('html, body').animate({scrollTop : 0}, 800);
      return false;
    });
    
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();

      if (scroll >= 300) {					
        element.addClass('is-active');					
      }
      else {								
        element.removeClass('is-active');
      }
    });
    
    var lastScroll = 0;

    $(window).scroll(function(){
      var scroll = $(window).scrollTop();
      if (scroll > lastScroll) {
        element.addClass("is-visible");
      }
      else if (scroll < lastScroll) {
        element.removeClass("is-visible");
      }
      lastScroll = scroll;
    });
    
    var progressPath = document.querySelector('.progress-page path');
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
    var updateProgress = function () {
      var scroll = $(window).scrollTop();
      var height = $(document).height() - $(window).height();
      var progress = pathLength - (scroll * pathLength / height);
      progressPath.style.strokeDashoffset = progress;
    }
    updateProgress();
    $(window).scroll(updateProgress);
  }
  
  function pageHeaderAnimation() {
    if (typeof $.fn.imagesLoaded == 'undefined' || theme.settings.animation == false) {
      return false;
    }
    
    $('.page-header-bg').imagesLoaded( { background: true }, function() {
	  $('.page-header-bg-wrapper').addClass('loaded');
      
      var tl = new TimelineLite(),
          header = $(".site-header__main"),
          topbar = $(".site-header__top"),
          page_title = $(".page-title"),
          subtitle = $(".term-description"),
          breadcrumbs = $(".breadcrumbs"),
          categories_bg = $(".page-categories, .page-meta_list"),
          delimiter = $(".page-delimiter"),
          arrow_back = $(".back-btn svg"),
          content = $(".content-area"),
          pagination = $(".site-pagination"),
          footer = $("#site-footer"),
          body = $('body');

      body.addClass('run-anim');
      tl.fromTo([header, topbar], 1, {autoAlpha:0,opacity:0}, {ease: Power4.easeInOut, autoAlpha:1, opacity:1}, .2).call(function(obj) {
        body.removeClass('run-anim');
      });;
      tl.fromTo(page_title, 1.2, {y:100, opacity:0}, {ease: Power4.easeInOut, y:0, opacity:1}, .3);
      tl.fromTo(subtitle, 1.4, {scale: 1.4, opacity:0}, {ease: Power4.easeInOut, scale: 1, opacity:1}, .2);
      tl.fromTo(arrow_back, 1, {x:20, opacity:0}, {ease: Power4.easeInOut,x:0, opacity:1}, .5);

      if ($('body').hasClass('template-collection')) {
        tl.fromTo(breadcrumbs, 1.2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1}, .25);
      }
      else if ($('body').hasClass('template-product')) {
        tl.fromTo(breadcrumbs, 1.2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1}, .6);
      }
      else {
        tl.fromTo(breadcrumbs, 1.2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1}, .25);
      }

      tl.fromTo(categories_bg, 1.4, {y:-40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1}, .25);
      tl.fromTo(delimiter, 1, {opacity:0, width:0}, {opacity:1, width:70}, .8);
      tl.fromTo([content, pagination], 1, {opacity:0}, {opacity:1}, .8);
      tl.fromTo(footer, 1, {opacity:0}, {opacity:1}, 1.5);
    });
  }
  
  function parallaxInit() {
    if (typeof ParallaxScroll == 'undefined' || typeof window.mobileCheck == 'undefined' || window.mobileCheck() || theme.settings.animation == false) {
      return false;
    }
    
    ParallaxScroll.init();
    //var rellax = new Rellax('.rellax', {});
  }
  
  function bgParallaxInit() {
    function ExtraScrollAnimator(options) {
      var self = this,
          $window = $(window),
          scrollTop = $window.scrollTop(),
          isActive = !0,
          wWidth = $window.width(),
          wHeight = $window.height(),
          isMin = null,
          isMax = null,
          isInside = null,
          isPaused = !1;
      
      self.init = function(_options) {
        self.options = $.extend({
          target: null,
          tween: null,
          ease: Linear.easeNone,
          min: 0,
          max: 1,
          minSize: 0,
          speed: 0.3,
          defaultProgress: 1,
          debug: !1,
          onMin: null,
          onMax: null,
          onOutside: null,
          onInside: null,
          onUpdate: null
        }, _options);
        if (self.options.target === null || self.options.target.length < 1) {
          console.warn("Extra Scroll Animator: no target specified");
          return !1
        }
        if (self.options.tween === null) {
          console.warn("Extra Scroll Animator: no tween specified");
          return !1
        }
        self.allowScrollUpdate = !0;
        self.update();
        self.repaint()
      };
      self.updatePosition = function(fast) {
        if (!isActive) {
          return
        }
        var time = (fast === undefined || !fast) ? self.options.speed : 0,
            coords = self.options.target.data('coords'),
            percent;
        if (!coords) {
          return
        }
        percent = 1 - (scrollTop - coords.max) / (coords.min - coords.max);
        if (percent <= 0 && isMin !== !0) {
          isMin = !0;
          if (isFunction(self.options.onMin)) {
            self.options.onMin()
          }
          self.options.target.trigger("extra:scrollanimator:min")
        } else if (percent > 0 && isMin !== !1) {
          isMin = !1
        }
        if (percent >= 1 && isMax !== !0) {
          isMax = !0;
          if (isFunction(self.options.onMax)) {
            self.options.onMax()
          }
          self.options.target.trigger("extra:scrollanimator:max")
        } else if (percent <= 1 && isMax !== !1) {
          isMax = !1
        }
        if ((isMin === !0 || isMax === !0) && isInside !== !1) {
          isInside = !1;
          if (isFunction(self.options.onOutside)) {
            self.options.onOutside()
          }
          self.options.target.trigger("extra:scrollanimator:outside")
        } else if (percent <= 1 && percent >= 0 && isInside !== !0) {
          isInside = !0;
          if (isFunction(self.options.onInside)) {
            self.options.onInside()
          }
          self.options.target.trigger("extra:scrollanimator:inside")
        }
        if (isInside === !1) {
          if (isMax) {
            percent = 1
          } else {
            percent = 0
          }
        }
        percent = Math.max(0, Math.min(percent));
        debug(percent);
        TweenLite.to(self.options.tween, time, {
          progress: percent,
          ease: self.options.ease
        })
      };
      self.update = function() {
        wWidth = $window.width();
        wHeight = $window.height();
        var coords = {},
            offsetTop = self.options.target.offset().top,
            height = self.options.target.height(),
            min = self.options.min,
            max = self.options.max;
        coords.min = offsetTop - wHeight + (wHeight * min);
        coords.max = (offsetTop - wHeight + height) + (wHeight * max);
        self.options.target.data("coords", coords);
        self.options.tween.paused(!0);
        self.options.tween.progress(self.options.defaultProgress);
        if (wWidth < self.options.minSize) {
          $window.off('scroll', scrollHandler)
        } else {
          $window.on('scroll', scrollHandler);
          self.updatePosition(!0)
        }
        if (isFunction(self.options.onUpdate)) {
          self.options.onUpdate(coords)
        }
        self.options.target.trigger("extra:scrollanimator:update", [coords])
      };
      $window.on('extra:resize', self.update);
      $window.on('extra:scrollanimator:resize', self.update);
      $window.on('extra:scrollanimator:tick', self.updatePosition);

      function scrollHandler(event) {
        scrollTop = $window.scrollTop();
        self.allowScrollUpdate = !0
      }
      self.repaint = function() {
        if (!isActive) {
          return
        }
        if (!self.allowScrollUpdate) {
          window.requestAnimationFrame(self.repaint);
          return
        }
        self.updatePosition();
        self.allowScrollUpdate = !1;
        window.requestAnimationFrame(self.repaint)
      };
      self.init(options);
      self.updateTween = function(tween) {
        if (self.options.tween) {
          self.options.tween.kill()
        }
        self.options.tween = tween;
        self.options.tween.paused(!0);
        self.options.tween.progress(self.options.defaultProgress);
        self.allowScrollUpdate = !0;
        self.update()
      };
      self.pause = function() {
        if (!isPaused) {
          $window.off('scroll', scrollHandler);
          $window.off('extra:resize', self.update);
          isActive = !1;
          isPaused = !0
        }
      };
      self.resume = function() {
        if (isPaused) {
          if (wWidth < self.options.minSize) {
            $window.off('scroll', scrollHandler)
          } else {
            $window.on('scroll', scrollHandler)
          }
          $window.on('extra:resize', self.update);
          isActive = !0;
          isPaused = !1;
          self.repaint()
        }
      };
      self.destroy = function() {
        isActive = !1;
        $window.off('scroll', scrollHandler);
        $window.off('extra:resize', self.update);
        $window.off('extra:scrollanimator:tick', self.updatePosition);
        if (self.options.tween) {
          self.options.tween.paused(!0);
          self.options.tween.progress(self.options.defaultProgress);
          self.options.tween.kill()
        }
        self.allowScrollUpdate = !1
      };

      function debug(string) {
        if (self.options.debug === !0) {
          console.log(string)
        }
      }

      function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]'
      }
    }

    window.initPrllx = function($container) {
      if ($('.site-main .article__image').length) {
        var TLPrllxs = [];
        var $container = $('.site-main');
        var $sections = $container.find('.article__image');
        $sections.each(function() {
          var $section = $(this),
              $inner = $section.children(),
              $separator = $section.find('.prllx'),
              tween,
              height = $inner.width(),
              scrollAnimator;

          tween = new TimelineLite({
            onUpdate: function() {}
          });

          tween.set($separator, {
            y: -1 * $separator.attr('data-prllx')
          }).to($separator, 1, {
            y: $separator.attr('data-prllx'),
            overwrite: "all",
            ease: Power0.easeNone
          }, '-=0.5');


          scrollAnimator = new ExtraScrollAnimator({
            target: $section,
            tween: tween,
            defaultProgress: 0,
            speed: 0,
            min: -0.2,
            max: 1.3,
          });

          $section.on("extra:scrollanimator:update", function(event) {
            event.stopPropagation()
          });
        });
      }
    }
    
    window.initSkrollr = function() {
      if ($('.site-main .skrollable').length == 0 || typeof skrollr == 'undefined') {
        return false;
      }
      
      $('.section__bground.skrollable').css("height", "120%").closest('.container-section').addClass('overflow-hidden');

      var skrollrOptions = {
        forceHeight: !1,
        smoothScrolling: !1,
        mobileCheck: function() {
          return !1
        }
      };
      skrollr.init(skrollrOptions);
    }
    
    $(window).on("load", function() {
      if (typeof window.mobileCheck != 'undefined' && !window.mobileCheck()) {
        window.initPrllx();
        window.initSkrollr();
      }
    });
  }
  
  function postsInview() {
    if ($('.blog-main .article__listing').length == 0 || typeof ScrollReveal == 'undefined' || theme.settings.animation == false) {
      return false;
    }
    
    window.sr = ScrollReveal();

    sr.reveal('.blog-main .article__listing', {
      opacity: 0,
      duration: 1600,
      mobile: true,
      viewFactor: 0,
    });
  }
  
  function pageHeaderInit() {
    var $body = $('body');
    if ($body.hasClass('page-faqs')) {
      var $header = $('.site-header-main');
      var height = $header.outerHeight();
      
      var element = '<div class="row" style="height:'+ height +';"></div>';
      $header.addClass('absolute').append(element);
    }
  }
  
  function splitText() {
    if (typeof window.mobileCheck == 'undefined') {
      return false;
    }
    
    if ($(window).width() > 992 && !window.mobileCheck()) {
      if ($('.products-grid.layout-2').length > 0) {
        var $quote = $(".products-grid.layout-2 .category__title:not(.split-text), .products-grid.layout-2 .product__link:not(.split-text), .product-single__notify label:not(.split-text)");
        $quote.each(function() {
          var $this = $(this);
          var mySplitText = new SplitText($this, {type:"lines"});
          $this.addClass("split-text").find("div").wrapInner("<span></span>");
        });
      }
    }
  }
  
  function productInfoAnimation(fromEl) {
    if (theme.settings.animation == false) {
      return false;
    }
    
    var	tl = new TimelineLite(),
        product_title = $(".product-single__title", fromEl),
        product_gallery_labels = $(".product-single .product__labels", fromEl),
        product_sidebar = $(".product-single .sidebar-container", fromEl),		  	
        product_share = $(".product-single__top .box-share-master-container", fromEl),
        product_tool_buttons = $(".product-single__right, .product-single__tools", fromEl),
        product_nav = $(".product-single__nav", fromEl),

        product_summary_middle = $(".product-single__middle", fromEl),
        product_summary_bottom = $(".product-single__bottom", fromEl);

    tl.fromTo(product_title, 1.6, {y:100, opacity:0}, {ease: Power4.easeInOut, y:0, opacity:1}, .7);
    tl.fromTo(product_summary_middle, 2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1 }, .8);
    tl.fromTo(product_summary_bottom, 2, {y:40, opacity:0}, {ease: Power4.easeInOut,y:0, opacity:1 }, 1);
    tl.fromTo([product_gallery_labels, product_share, product_tool_buttons, product_nav, product_sidebar], 2, {opacity:0}, {ease: Power4.easeInOut,opacity:1 }, .7);
  }
  
  function animationProduct() {
    if (typeof ScrollReveal == 'undefined' || theme.settings.animation == false) {
      return false;
    }
    
    window.sr = ScrollReveal();

    sr.reveal('.products-grid .product:not(.active)', { 
      opacity: 0,
      viewFactor: 0.2,
      afterReveal: revealProductElements,
      beforeReveal: function (domEl) {
        domEl.classList.add('active');
        var product_img = $(domEl).find('.product__image, .category__image');
        if (product_img !== null) {
          domEl.visuelRevealTL = new TimelineLite(),
            domEl.visuelRevealTL.fromTo(product_img, 2, {scale:1.1}, {ease: Power4.easeOut, scale:1},0); 
        }
      } 
    }, 150);


    function revealProductElements(domEl) {
      if (typeof window.mobileCheck == 'undefined' || theme.settings.animation == false) {
        return false;
      }
      
      domEl.classList.add('active');
      var quote = $(domEl).find('.product__link div span, .category__title div span'),
          elements = $(domEl).find('.product__review, .more-products'),
          price = $(domEl).find('.product__price');

      domEl.visuelRevealTL = new TimelineLite();

      if ($(window).width() > 992 && !window.mobileCheck()) {
        if ($('.products-grid.layout-2').length > 0) {
          domEl.visuelRevealTL.fromTo(quote, 1, {ease: Power4.easeOut, x:30, y:100, skewX:60, opacity:0}, {ease: Power4.easeOut, x:0, y:0, skewX:0,  opacity:1}, 0);
          if (elements !== null) {
            domEl.visuelRevealTL.fromTo(elements, 2, {y:10, opacity:0}, {ease: Power4.easeOut, y:0, opacity:1},.4);
          }
          if (price !== null) {
            domEl.visuelRevealTL.fromTo(price, 2, {y:10}, {ease: Power4.easeOut, y:0, opacity:1},.2);
          }
        }
      }
    }
  }
  
  function pageAnimation() {
    parallaxInit();
    bgParallaxInit();
    //pageHeaderInit();
    pageHeaderAnimation();
    productInfoAnimation($('.product-template__container'));
    postsInview();
    splitText();
    animationProduct();
  }
  
  function shareInit() {
    if ($('.social-sharing').length == 0 || typeof $.fn.socialShare == 'undefined') {
      return false;
    }
    
    $('.social-sharing').each(function() {
      var that = $(this);

      that.socialShare({
        name: that.data('name'),
        title: that.data('title'),
        mediaUrl: that.data('share_img'),
        social: that.data('share_elem'),
        animation: 'launchpadReverse',
        blur: true
      });
    });
  }
  
  function mobileCategories() {
    $('body').on('click', '.barberry-show-categories', function(evt) {
      evt.preventDefault();
      
      var that = $(this);
      var parent = that.closest('.page-categories-wrapper');

      if (that.hasClass('opened')) {
        var tl = new TimelineLite(),
            categories = parent.find(".barberry-categories"),
            categories_items = parent.find(".barberry-categories .category_item");

        tl.fromTo(categories, 1, {
          "max-height": 1000,
          autoAlpha: 1
        }, {
          autoAlpha: 0,
          "max-height": 0,
          ease: Power3.easeInOut
        }, 0);

        setTimeout(function() {
          that.removeClass('opened');
          categories.removeClass('opened');
        }, 700);
      }
      else {
        var tl = new TimelineLite(),
            categories = parent.find(".barberry-categories"),
            categories_items = parent.find(".barberry-categories .category_item");

        tl.fromTo(categories, 1, {
          "max-height": 0,
          autoAlpha: 0
        }, {
          "max-height": 1000,
          autoAlpha: 1,
          ease: Power4.easeIn
        }, 0);
        tl.staggerFromTo(categories_items, 1, {
          opacity: 0,
          scale: 2,
          skewX: 30
        }, {
          opacity: 1,
          scale: 1,
          skewX: 0,
          ease: Power4.easeOut
        }, .1, .3);

        setTimeout(function() {
          categories.addClass('opened');
          that.addClass('opened');
        }, 500);
      }
    });
  }
  
  function roarSlider() {
    $('[data-roarslider]').each(function() {
      var $this = $(this);
      var revapi = 'revapi' + $this.data('roarslider');
      
      document.addEventListener(revapi, function(evt) {
        $this.addClass('loaded');
      }, false);
    });
  }
  
  function bgSet(image) {
    if (image) {
      var aspect_ratio = image.width / image.height;
      var bgset = '';
      var sizes = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2048];

      sizes.forEach(function(size) {
        if (image.width > size) {
          bgset += theme.Images.getSizedImageUrl(image.src, size + 'x') + ' ' + size + 'w ' + Math.round(size / aspect_ratio) + 'h,';
        }
      });
      bgset += theme.Images.getSizedImageUrl(image.src, 'master') + ' ' + image.width + 'w ' + image.height + 'h';

      return bgset;
    }
  }
  
  function fixtooltipHover() {
    $(".products .product .product__item").hover(
      function() {
        setTimeout(function() {
          $(this).addClass("phover");
        }.bind(this), 200)
      },
      function() {
        setTimeout(function() {
          $(this).removeClass("phover");
        }.bind(this), 200)
      }
    );
  }

  return {
    init: function() {
      pageLoader();
      ageCheck();
      
      shareInit();
      pageAnimation();
      mobileCategories();

      roarLookbook.init();
      initLookbook();
      roarSlider();

      scrollDownAnchor();
      tiltHoverEffect();
      shortcodes();

      toggleSidebar();
      toggleCategories();

      quickView();
      productColors();

      addCart();
      optionsCart();

      addWishlist();
      removeWishlist();
      loadWishlist();

      initCompare();
      addCompare();
      removeCompare();
      
      
      initCompare();
      addCompare();
      removeCompare();

      initAlert();
      passwordPage();
      ajaxComplete();

      footerInit();
      backtoTop();
      
      fixtooltipHover();
    },
    bgSet: bgSet,
    backHistory: backHistory,
    initReviews: initReviews,
    splitText: splitText,
    animationProduct: animationProduct,
    productInfoAnimation: productInfoAnimation,
    fixtooltipHover: fixtooltipHover,
  };
})();

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('cart-gift', theme.CartGift);
  sections.register('shipping-calculator', theme.ShippingCalculator);
  sections.register('collection-template', theme.Filters);
  sections.register('sidebar-sticky', theme.SidebarSticky);
  sections.register('product-template', theme.Product);
  sections.register('header-mobile', theme.HeaderMobile);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('line_item', theme.LineItem);
  sections.register('instagram', theme.Instagram);
  sections.register('countdown-timer', theme.CountdownTimer);
  sections.register('products-slider', theme.ProductsSlider);
  sections.register('product-tabs', theme.ProductTabs);
  sections.register('newsletter-popup', theme.NewsletterPopup);
  sections.register('lookbook-section', theme.LookbookSection);
  sections.register('rich-banner', theme.RichBanner);
  sections.register('collections-slider', theme.CollectionsSlider);
});

theme.init = function() {
  theme.roarJs.init();
  theme.customerTemplates.init();
  
  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  $(document).one('touchstart', function() {
    theme.Helpers.setTouch();
  });

  /* a11y: Escape key dismisses tooltips (WCAG 1.4.13) */
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('.has-tooltip .tooltip').css('visibility', 'hidden');
      setTimeout(function() { $('.has-tooltip .tooltip').css('visibility', ''); }, 100);
    }
  });
};

$(theme.init);

/*
$('#shopify-product-reviews').on('DOMSubtreeModified', function() {
  var $this = $(this);
  if (!$this.hasClass('customized') && $this.find('.spr-reviews').length) {
    $this.addClass('customized');
    
    setTimeout(function() {
      $this.find('.spr-header').append($this.find('.spr-reviews'));
    }, 300);
  }
});
*/

document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});